// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file envelope/envelope.proto (package lvdr.v2.envelope, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { FeaturesUpdatedEvent } from "../admin/admin_pb";
import { file_admin_admin } from "../admin/admin_pb";
import type { ErrorResponse } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { CancelReportRunRequest, CancelReportRunResponse, ConfigGoRequest, ConfigGoResponse, CreateResearchRequest, DeleteDiagramRequest, DeleteDiagramResponse, DeleteResearchRequest, DiagramEnhancementJobUpdateEvent, EstimateReportRunRequest, EstimateReportRunResponse, GenerateReportRequest, GenerateReportResponse, GenerateSummaryRequest, GetResearchAppendixRequest, GetResearchDefaultsCatalogRequest, GetResearchDefaultsCatalogResponse, GetResearchDiagramsRequest, GetResearchRequest, GetResearchResultRequest, GetResearchStatsRequest, ListResearchOutputFormsRequest, ListResearchOutputFormsResponse, ListResearchRequest, MetadataRequest, MetadataResponse, PinDiagramToReportRequest, PinDiagramToReportResponse, RegenerateDiagramRequest, RegenerateDiagramResponse, RegenerateResearchTitleRequest, RegenerateResearchTitleResponse, ReportRunProgressEvent, ResearchAppendixResponse, ResearchConfigRequest, ResearchConfigResponse, ResearchCreatedEvent, ResearchDiagramAddedEvent, ResearchDiagramRemovedEvent, ResearchDiagramsResponse, ResearchDiagramUpdatedEvent, ResearchListResponse, ResearchReportRevisedEvent, ResearchResponse, ResearchResultResponse, ResearchStatsResponse, ResearchStatusUpdateEvent, ResearchUpdatedEvent, RunDiagramEnhancementRequest, RunDiagramEnhancementResponse, SaveResearchAsDocumentRequest, SaveResearchAsDocumentResponse, SetResearchPriorityRequest, SetResearchPriorityResponse, SetResearchReferenceRequest, SetResearchTagsRequest, SubscribeResearchListRequest, SubscribeResearchRequest, SummaryResponse, UnpinDiagramRequest, UnpinDiagramResponse, UnsubscribeResearchListRequest, UnsubscribeResearchRequest, UpdateDiagramCaptionRequest, UpdateDiagramCaptionResponse, UpdateResearchRequest } from "../research/research_pb";
import { file_research_research } from "../research/research_pb";
import type { ResearchFindingsEvent, ResearchInsightDigestEvent, ResearchProgressView } from "../research/progress_view_pb";
import { file_research_progress_view } from "../research/progress_view_pb";
import type { CancelExecutionRequest, DelayNotificationEvent, DismissResearchErrorRequest, DismissResearchErrorResponse, ExecuteRetryPlanRequest, ExecutionActivityEvent, ExecutionCancelledEvent, ExecutionCompletedEvent, ExecutionFailedEvent, ExecutionPausedEvent, ExecutionProgressEvent, ExecutionStartedEvent, GetRetryPlanRequest, IgnoreFailedNodesRequest, IgnoreFailedNodesResponse, MarkNodesForRetryRequest, MarkNodesForRetryResponse, PauseExecutionRequest, RaiseCreditCeilingRequest, RaiseCreditCeilingResponse, ReAggregateRequest, RestartExecutionRequest, ResumeExecutionRequest, RetryExecutionRequest, RetryPlanResponse, StartExecutionRequest, StartOverRequest, StartOverResponse, UpdateResearchBudgetRequest, UpdateResearchBudgetResponse } from "../execution/execution_pb";
import { file_execution_execution } from "../execution/execution_pb";
import type { GetNodeRequest, GetNodeTreeRequest, NodeResponse, NodeStatusChangedEvent, NodeTreeResponse, NodeUpdateEvent, SubscribeNodesRequest, UnsubscribeNodesRequest } from "../node/node_pb";
import { file_node_node } from "../node/node_pb";
import type { AddUserMcpServerRequest, AddUserMcpServerResponse, AgentAuditEvent, AgentStepEvent, ChatHistoryResponse, ChatMessageEvent, ChatMessageStreamEvent, ChatRetrievalEvent, ChatSessionListResponse, ChatSessionResponse, ChatSessionUpdatedEvent, CountChatSessionFactsRequest, CountChatSessionFactsResponse, CreateChatSessionRequest, DeleteChatSessionRequest, GetChatHistoryRequest, GetTurnTraceRequest, GetTurnTraceResponse, GroundingReport, InterjectRequest, InterjectResponse, ListChatSessionsRequest, ListUserMcpServersRequest, ListUserMcpServersResponse, MoveChatSessionContextRequest, MoveChatSessionContextResponse, RemoveUserMcpServerRequest, RemoveUserMcpServerResponse, ResumeAgentRequest, SaveChatNoteRequest, SaveChatNoteResponse, SendMessageRequest, SubscribeChatSessionRequest, TestUserMcpServerRequest, TestUserMcpServerResponse, ThinkHarderRequest, UIActionEvent, UnsubscribeChatSessionRequest, UpdateChatSessionRequest, UpdateUserMcpServerRequest, UpdateUserMcpServerResponse } from "../chat/chat_pb";
import { file_chat_chat } from "../chat/chat_pb";
import type { AcquireEditLockRequest, AcquireEditLockResponse, AddSnapshotTagRequest, CreateSnapshotRequest, CreateWorkspaceNoteRequest, CreateWorkspaceNoteSnapshotRequest, DeleteWorkspaceNoteRequest, DeleteWorkspaceNoteResponse, ExportWorkspaceRequest, ExportWorkspaceResponse, GetSnapshotRequest, GetWorkspaceNoteRequest, GetWorkspaceNoteSnapshotRequest, ListSnapshotsRequest, ListSnapshotsResponse, ListWorkspaceNoteSnapshotsRequest, ListWorkspaceNotesRequest, ListWorkspaceNotesResponse, MountWorkspaceRequest, MountWorkspaceResponse, PresenceEvent, RekeyWorkspaceRequest, RekeyWorkspaceResponse, ReleaseEditLockRequest, ReleaseEditLockResponse, SetActiveWorkspaceRequest, SetActiveWorkspaceResponse, SetSnapshotLegalHoldRequest, SnapshotContentResponse, SnapshotResponse, TransferContentCompletedEvent, TransferContentRequest, TransferContentResponse, UnmountWorkspaceRequest, UnmountWorkspaceResponse, UpdateWorkspaceNoteRequest, WorkspaceChangeEvent, WorkspaceNoteResponse, WorkspaceNotificationEvent } from "../workspace/workspace_pb";
import { file_workspace_workspace } from "../workspace/workspace_pb";
import type { AttachResearchScopeRequest, BuildIndexRequest, BuildIndexResponse, CollectionListResponse, CollectionResponse, CreateCollectionRequest, CreateScopeRequest, DeleteCollectionRequest, DeleteDocumentRequest, DeleteScopeRequest, DetachResearchScopeRequest, DocumentContentResponse, DocumentIndexingCompletedEvent, DocumentIndexingProgressEvent, DocumentListChangedEvent, DocumentListResponse, DocumentResponse, GetDocumentContentRequest, GetDocumentRequest, GetIndexInfoRequest, GetScopeTreeRequest, GetScopeTreeResponse, IndexInfoResponse, IndexStatusChangedEvent, LinkDocumentRequest, ListCollectionsRequest, ListDocumentsRequest, ListResearchDocumentsRequest, ListResearchScopesRequest, ListScopesRequest, ListTagVocabularyRequest, ListTagVocabularyResponse, ReorderResearchScopesRequest, ResearchScopeListResponse, RetryDoclingRequest, RetryDoclingResponse, RetryDocumentRequest, ScopeListResponse, ScopeResponse, ScopeToContextApplyRequest, ScopeToContextApplyResponse, ScopeToContextPreviewRequest, ScopeToContextPreviewResponse, SearchDocumentsRequest, SearchResultsResponse, SetConverterChoiceRequest, SetConverterChoiceResponse, SubscribeDocumentIndexingRequest, SuggestTagsRequest, SuggestTagsResponse, UnlinkDocumentRequest, UnsubscribeDocumentIndexingRequest, UpdateCollectionRequest, UpdateDocumentMetadataRequest, UpdateDocumentTagsRequest, UpdateIndexRequest, UpdateIndexResponse, UpdateScopeRequest, UploadDocumentRequest } from "../document/document_pb";
import { file_document_document } from "../document/document_pb";
import type { AuthenticationOptionsResponse, AuthenticationSuccessResponse, BeginAuthenticationRequest, BeginRegistrationRequest, CompleteAuthenticationRequest, CompleteRegistrationRequest, GetSubscriptionStateRequest, GetSubscriptionStateResponse, LogoutRequest, LogoutResponse, RegistrationOptionsResponse, SessionRevokedEvent } from "../auth/auth_pb";
import { file_auth_auth } from "../auth/auth_pb";
import type { GetSettingsRequest, GetUserSettingsRequest, SettingsChangedEvent, SettingsResponse, UpdateSettingsRequest, UpdateUserSettingsRequest, UserSettingsResponse } from "../settings/settings_pb";
import { file_settings_settings } from "../settings/settings_pb";
import type { AutoRefillCheckoutEvent, AutoRefillSettingsResponse, CreditBalanceResponse, CreditBalanceUpdatedEvent, CreditsBreakdownResponse, CreditsExhaustedEvent, CreditsLowWarningEvent, CreditsRefilledEvent, GetAutoRefillSettingsRequest, GetChatCreditsRequest, GetChatCreditsResponse, GetCreditBalanceRequest, GetCreditsBreakdownRequest, GetVoiceCreditsRequest, GetVoiceCreditsResponse, SeatRevokedEvent, TierChangedEvent, UpdateAutoRefillSettingsRequest } from "../budget/budget_pb";
import { file_budget_budget } from "../budget/budget_pb";
import type { BudgetHITLEvent, BudgetHITLResponse, EnricherClarificationRequestEvent, EnricherClarificationResponseMsg, GuidanceRequestEvent, GuidanceResponseMsg, HITLCancelledEvent, HITLPendingRequest, HITLPendingResponse, HITLRequestEvent, HITLResponseMsg, HITLTimeoutEvent, OffTopicDetectionEvent, QualityGateEvent, ReportRunCostApproval, ResearchWrappingUpEvent, StopResearchEvent, ToolAuthRequestEvent, ToolAuthResponseMsg, WrapUpResearchMsg } from "../hitl/hitl_pb";
import { file_hitl_hitl } from "../hitl/hitl_pb";
import type { GetTemplatesRequest, GetTemplatesResponse, ListProfilesRequest, ListProfilesResponse, PromptBuilderMessageEvent, SendPromptBuilderMessageRequest } from "../prompt/prompt_pb";
import { file_prompt_prompt } from "../prompt/prompt_pb";
import type { ExportResearchRequest, ExportResearchResponse, ExportStatusEvent } from "../export/export_pb";
import { file_export_export } from "../export/export_pb";
import type { SearchRequest, SearchResponse } from "../search/search_pb";
import { file_search_search } from "../search/search_pb";
import type { BatchApproveReviewsRequest, BatchApproveReviewsResponse, CreateEntityRequest, CreateRelationRequest, CreateTopicRequest, DeleteEntityRequest, DeleteRelationRequest, DeleteTopicRequest, EntityListResponse, EntityResponse, ExportMemoryRequest, ExportMemoryResponse, GetEntityRequest, GetGraphRequest, GetMemorySettingsRequest, GetReviewQueueRequest, GraphResponse, ImportMemoryRequest, ImportMemoryResponse, ListEntitiesRequest, ListTopicsRequest, MemoryEntityChangedEvent, MemoryReviewAvailableEvent, MemorySettingsResponse, RelationResponse, ResolveReviewRequest, ResolveReviewResponse, ReviewQueueResponse, SearchEntitiesRequest, SearchEntitiesResponse, SubscribeMemoryRequest, ToggleExtractionRequest, TopicListResponse, TopicResponse, UnsubscribeMemoryRequest, UpdateEntityRequest, UpdateMemorySettingsRequest, UpdateTopicRequest } from "../memory/memory_pb";
import { file_memory_memory } from "../memory/memory_pb";
import type { CryptoSessionKill, CryptoSessionUnlocked, CryptoUnlockChallenge, CryptoUnlockResponse, GetKeyRotationStatusRequest, KeyRotationStatusResponse, RotationStatusEvent } from "../crypto/crypto_pb";
import { file_crypto_crypto } from "../crypto/crypto_pb";
import type { AccessDecisionEvent, AccessGrantListResponse, AccessRequestEvent, GetAuditEventRequest, GetAuditEventResponse, GetModelTrustConfigRequest, GetThresholdConfigRequest, ListAccessRequestsRequest, ListAuditEventsRequest, ListAuditEventsResponse, ListMyAccessRequestsRequest, ModelTrustConfigResponse, RevealNodeRequest, RevealNodeResponse, SecurityAlert, SecuritySummary, SecuritySummaryRequest, SimulateSecurityDecisionRequest, SimulateSecurityDecisionResponse, SubmitAuditFeedbackRequest, SubmitAuditFeedbackResponse, SubmitSourceFeedbackRequest, SubmitSourceFeedbackResponse, ThresholdConfigResponse, UpdateDomainReputationRequest, UpdateDomainReputationResponse, UpdateModelTrustConfigRequest, UpdateThresholdConfigRequest } from "../security/security_pb";
import { file_security_security } from "../security/security_pb";
import type { DrainNotice, SessionMovedFrame, SessionRedirect } from "../cluster/cluster_pb";
import { file_cluster_cluster } from "../cluster/cluster_pb";
import type { CreateNoteFolderRequest, CreateNoteRequest, CreateNoteSnapshotRequest, DeleteNoteFolderRequest, DeleteNoteFolderResponse, DeleteNoteRequest, DeleteNoteResponse, GetNoteRequest, GetNoteSnapshotRequest, GetOrCreateDailyNoteRequest, LinkNoteRequest, ListNoteFoldersRequest, ListNotesByLinkRequest, ListNotesByLinkResponse, ListNoteSnapshotsRequest, ListNotesRequest, NoteAIRequest, NoteAIResponse, NoteFolderListResponse, NoteFolderResponse, NoteListResponse, NoteResearchRequest, NoteResearchResponse, NoteResponse, NoteSnapshotContentResponse, NoteSnapshotListResponse, SearchNoteEntitiesRequest, SearchNoteEntitiesResponse, UnlinkNoteRequest, UpdateNoteFolderRequest, UpdateNoteRequest } from "../note/note_pb";
import { file_note_note } from "../note/note_pb";
import type { AddTaskTagRequest, CreateSeriesRequest, CreateTaskRequest, DeleteSeriesRequest, DeleteSeriesResponse, DeleteTaskRequest, DeleteTaskResponse, GetTaskRequest, LinkTaskRequest, ListSeriesRequest, ListTasksByLinkRequest, ListTasksByLinkResponse, ListTasksRequest, PauseSeriesRequest, RemoveTaskTagRequest, ResolveTaskAttentionSuggestionRequest, SeriesListResponse, SeriesResponse, SkipOccurrenceRequest, SuggestTaskAttentionRequest, SuggestTaskAttentionResponse, TaskListResponse, TaskResponse, UnlinkTaskRequest, UpdateSeriesRequest, UpdateTaskRequest } from "../tasks/tasks_pb";
import { file_tasks_tasks } from "../tasks/tasks_pb";
import type { GetPersonalContextRequest, PersonalContextResponse, UpdatePersonalContextRequest } from "../personalcontext/personalcontext_pb";
import { file_personalcontext_personalcontext } from "../personalcontext/personalcontext_pb";
import type { ContextEraseExportRequest, ContextEraseExportResponse, ContextEraseRequest, ContextEraseResponse, ContextFactsOnNodeRequest, ContextFactsOnNodeResponse, ContextGraphGetRequest, ContextGraphResponse, ContextHistoryListRequest, ContextHistoryListResponse, ContextImpactPreview, ContextInspection, ContextInspectRequest, ContextItemClassificationGetRequest, ContextItemClassificationResponse, ContextItemClassificationSetRequest, ContextItemsOnNodeRequest, ContextItemsOnNodeResponse, ContextLastUsedGetRequest, ContextLastUsedResponse, ContextLastUsedSetRequest, ContextLinksGetRequest, ContextLinksResponse, ContextLinksSetRequest, ContextNodeArchiveRequest, ContextNodeCreateRequest, ContextNodeResponse, ContextNodeSetParentsRequest, ContextNodeUpdateRequest, ContextOperateRequest, ContextOperateResponse, ContextPersonalityGetRequest, ContextPersonalityResponse, ContextPersonalitySetRequest, ContextPreviewPropertiesRequest, ContextProposalDismissRequest, ContextProposalsApplyRequest, ContextProposalsApplyResponse, ContextProposalsChangedEvent, ContextProposalsListRequest, ContextProposalsListResponse, ContextSignalsRunRequest, ContextSignalsRunResponse, ContextUndoRequest, ContextUndoResponse, ContextUnitLinksSetRequest, ContextUnitLinksSetResponse, ContextUnsortedListRequest, ContextUnsortedListResponse } from "../context/context_pb";
import { file_context_context } from "../context/context_pb";
import type { AuthorizeBackgroundRequest, BackgroundAuthResponse, GetPushConfigRequest, ListBackgroundAuthRequest, ListSealedOpeningsRequest, ListSealedOpeningsResponse, PushConfigResponse, RegisterPushSubscriptionRequest, RemovePushSubscriptionRequest, RevokeBackgroundRequest, SetBackgroundAccountRequest } from "../bgauth/bgauth_pb";
import { file_bgauth_bgauth } from "../bgauth/bgauth_pb";
import type { DAGGraphEvent, GetCachedPageRequest, GetCachedPageResponse, GetDAGGraphRequest, GetDAGGraphResponse, GetDAGNodeChannelRequest, GetDAGNodeChannelResponse, GetDAGNodeContentRequest, GetDAGNodeContentResponse, GetDAGNodeRequest, GetDAGNodeResponse, IgnoreNodeRequest, InvalidateNodeRequest, PauseGraphRequest, ResumeGraphRequest, RetryNodeRequest, SubmitHITLCriteriaRequest, SubmitHITLCriteriaResponse, SubscribeDAGRequest, UnsubscribeDAGRequest } from "../dag/dag_pb";
import { file_dag_dag } from "../dag/dag_pb";
import type { BrowseKnowledgeRequest, BrowseKnowledgeResponse, BrowseResearchContextRequest, BrowseResearchContextResponse, DeleteKnowledgeNodeRequest, DeleteKnowledgeNodeResponse, GetKnowledgeNodeRequest, GetKnowledgeNodeResponse, GetNodeUsageRequest, GetNodeUsageResponse, KnowledgeChangedEvent, KnowledgeSearchProgressEvent, ListKnowledgeGapsRequest, ListKnowledgeGapsResponse, PromoteResearchContextRequest, PromoteResearchContextResponse, ResearchNodeDetailRequest, ResearchNodeDetailResponse, SearchKnowledgeRequest, SearchKnowledgeResponse, SearchResearchContextRequest, SearchResearchContextResponse, UpdateKnowledgeNodeRequest, UpdateKnowledgeNodeResponse } from "../knowledge/knowledge_pb";
import { file_knowledge_knowledge } from "../knowledge/knowledge_pb";
import type { ExpertiseResponse, GetExpertiseRequest, KnownTopicsResponse, ListKnownTopicsRequest, UpdateExpertiseRequest } from "../expertise/expertise_pb";
import { file_expertise_expertise } from "../expertise/expertise_pb";
import type { ArtifactListResponse, ListArtifactsRequest } from "../artifact/artifact_pb";
import { file_artifact_artifact } from "../artifact/artifact_pb";
import type { CreateSkillRequest, DeleteSkillRequest, DeleteSkillResponse, GenerateSkillRequest, GenerateSkillResponse, ListAvailableEnhancementsRequest, ListAvailableEnhancementsResponse, ListSkillsRequest, ListSkillsResponse, RunEnhancementRequest, RunEnhancementResponse, SkillPrefsResponse, SkillResponse, UpdateSkillPrefsRequest, UpdateSkillRequest } from "../skill/skill_pb";
import { file_skill_skill } from "../skill/skill_pb";
import type { ConnectorAuthResponse, ConnectorAuthStatusResponse, ConnectorResponse, GetConnectorAuthStatusRequest, GetConnectorRequest, ListConnectorsRequest, ListConnectorsResponse, MoveConnectionRequest, MoveConnectionResponse, RevokeConnectorAuthRequest, StoreConnectorAuthRequest, TestConnectorRequest, TestConnectorResponse } from "../connector/connector_pb";
import { file_connector_connector } from "../connector/connector_pb";
import type { ApproveWorkflowStepRequest, ApproveWorkflowStepResponse, CancelWorkflowInstanceRequest, CancelWorkflowInstanceResponse, CapabilityDriftAlert, CreateTriggerRequest, CreateWorkflowRequest, CreateWorkflowResponse, DeleteTriggerRequest, DeleteTriggerResponse, DeleteWorkflowDraftRequest, DeleteWorkflowDraftResponse, DeleteWorkflowRequest, DeleteWorkflowResponse, DeleteWorkflowTemplateRequest, DeleteWorkflowTemplateResponse, DeployWorkflowRequest, DeployWorkflowResponse, DesignerTurnStreamEvent, FireManualTriggerRequest, FireManualTriggerResponse, GetTriggerHistoryRequest, GetWorkflowInstanceRequest, GetWorkflowRequest, InstantiateWorkflowTemplateRequest, InstantiateWorkflowTemplateResponse, ListSendGrantsRequest, ListTriggersRequest, ListTriggersResponse, ListWorkflowInstancesRequest, ListWorkflowInstancesResponse, ListWorkflowsRequest, ListWorkflowsResponse, ListWorkflowTemplatesRequest, ListWorkflowTemplatesResponse, ManualActionsRequest, ManualActionsResponse, PublishWorkflowRequest, PublishWorkflowResponse, ResumeReconnectWorkflowStepRequest, ResumeReconnectWorkflowStepResponse, RevokeSendGrantRequest, RunDesignerTurnRequest, RunDesignerTurnResponse, RunWorkflowRequest, RunWorkflowResponse, SaveWorkflowAsTemplateRequest, SaveWorkflowAsTemplateResponse, SendGrantsResponse, TriggerCatalogRequest, TriggerCatalogResponse, TriggerHistoryResponse, TriggerResponse, UpdateTriggerRequest, UpdateWorkflowRequest, UpdateWorkflowResponse, ValidateWorkflowRequest, ValidateWorkflowResponse, WorkflowInstanceResponse, WorkflowResponse, WorkflowResultEvent } from "../workflow/workflow_pb";
import { file_workflow_workflow } from "../workflow/workflow_pb";
import type { CostsByGroupResponse, GetCostsByGroupRequest, GetHourlyCostsRequest, GetHourlyUsageRequest, GetStorageBreakdownRequest, GetUsageHistoryRequest, GetUsageSummaryRequest, HourlyCostsResponse, HourlyUsageResponse, StorageBreakdownResponse, UsageHistoryResponse, UsageSummaryResponse } from "../usage/usage_pb";
import { file_usage_usage } from "../usage/usage_pb";
import type { BillingBalanceResponse, GetBillingBalanceRequest } from "../billing/billing_pb";
import { file_billing_billing } from "../billing/billing_pb";
import type { CancelTranscriptionRequest, CancelTranscriptionResponse, DeleteRecordingRequest, DeleteRecordingResponse, GetRecordingRequest, GetRecordingResponse, ListRecordingsRequest, ListRecordingsResponse, PromoteRecordingRequest, PromoteRecordingResponse, RecordingStatusEvent, RetryTranscriptionRequest, RetryTranscriptionResponse, UpdateRecordingRequest, UpdateRecordingResponse } from "../recordings/recordings_pb";
import { file_recordings_recordings } from "../recordings/recordings_pb";
import type { ErrorEvent } from "../errors/errors_pb";
import { file_errors_errors } from "../errors/errors_pb";
import type { ApplyPersonaRequest, ApplyPersonaResponse, CompleteOnboardingRequest, CompleteOnboardingResponse, GetOnboardingStateRequest, GetOnboardingStateResponse, ListPersonasRequest, ListPersonasResponse } from "../persona/persona_pb";
import { file_persona_persona } from "../persona/persona_pb";
import type { GetMantraRequest, MantraResponse, UpdateMantraRequest } from "../mantra/mantra_pb";
import { file_mantra_mantra } from "../mantra/mantra_pb";
import type { AudioEpisodeEvent, DeleteAudioOverviewRequest, DeleteAudioOverviewResponse, GetAudioOverviewRequest, GetAudioOverviewResponse, ListAudioOverviewsRequest, ListAudioOverviewsResponse } from "../audio/audio_pb";
import { file_audio_audio } from "../audio/audio_pb";
import type { DeckApplyOpsRequest, DeckApplyOpsResponse, DeckChangedEvent, DeckChatEditRequest, DeckChatEditResponse, DeckCreateRequest, DeckCreateResponse, DeckExportPdfRequest, DeckExportPdfResponse, DeckExportPptxRequest, DeckExportPptxResponse, DeckGenerateImageRequest, DeckGenerateImageResponse, DeckGetRequest, DeckGetResponse, DeckListRequest, DeckListResponse, DeckRenderDiagramRequest, DeckRenderDiagramResponse } from "../deck/deck_pb";
import { file_deck_deck } from "../deck/deck_pb";
import type { ListChatPromptsRequest, ListChatPromptsResponse } from "../chatprompts/chatprompts_pb";
import { file_chatprompts_chatprompts } from "../chatprompts/chatprompts_pb";
import type { InboxClearTriageLabelRequest, InboxClearTriageLabelResponse, InboxConfirmRuleProposalRequest, InboxConfirmRuleProposalResponse, InboxConnectMailboxRequest, InboxConnectMailboxResponse, InboxDisconnectMailboxRequest, InboxDisconnectMailboxResponse, InboxDismissRuleProposalRequest, InboxDismissRuleProposalResponse, InboxDraftReplyRequest, InboxDraftReplyResponse, InboxGetContextCardRequest, InboxGetContextCardResponse, InboxGetConversationRequest, InboxGetConversationResponse, InboxGetConvRulesRequest, InboxGetConvRulesResponse, InboxGetDraftContextRequest, InboxGetDraftContextResponse, InboxGetInteractionTextRequest, InboxGetInteractionTextResponse, InboxGetTriageCountRequest, InboxGetTriageCountResponse, InboxGetTriageReportRequest, InboxGetTriageReportResponse, InboxListMailboxesRequest, InboxListMailboxesResponse, InboxListSelfHandlesRequest, InboxListSelfHandlesResponse, InboxListTriageRequest, InboxListTriageResponse, InboxPreviewConvRulesRequest, InboxPreviewConvRulesResponse, InboxSetCallSourceRequest, InboxSetCallSourceResponse, InboxSetConvRulesRequest, InboxSetConvRulesResponse, InboxSetLoopDismissedRequest, InboxSetLoopDismissedResponse, InboxSetMailboxFilterRequest, InboxSetMailboxFilterResponse, InboxSetMailboxLabelRequest, InboxSetMailboxLabelResponse, InboxSetSelfHandlesRequest, InboxSetSelfHandlesResponse, InboxSetStyleOverrideRequest, InboxSetStyleOverrideResponse, InboxSetTriageLabelRequest, InboxSetTriageLabelResponse, InboxSyncProgress, InboxTelegramConnectRequest, InboxTelegramConnectResponse, InboxTelegramStatusRequest, InboxTelegramStatusResponse, InboxTestMailboxRequest, InboxTestMailboxResponse, InboxTriageCount } from "../inbox/inbox_pb";
import { file_inbox_inbox } from "../inbox/inbox_pb";
import type { NeedsYouChangedEvent, NeedsYouListRequest, NeedsYouListResponse, NeedsYouResolveRequest, NeedsYouResolveResponse } from "../needsyou/needsyou_pb";
import { file_needsyou_needsyou } from "../needsyou/needsyou_pb";
import type { BridgeDraftRequest, BridgeDraftResponse, BridgeRequestGetRequest, BridgeRequestGetResponse, BridgeResolveRequest, BridgeResolveResponse, BridgeSetSendApprovalRequest, BridgeSetSendApprovalResponse } from "../bridge/bridge_pb";
import { file_bridge_bridge } from "../bridge/bridge_pb";
import type { ListWorkBatchesRequest, ListWorkBatchesResponse, UpdateWorkBatchOverridesRequest, UpdateWorkBatchOverridesResponse } from "../cos/workbatch_pb";
import { file_cos_workbatch } from "../cos/workbatch_pb";
import type { GetNextWorkRequest, GetNextWorkResponse, ReportActivityRequest, ReportActivityResponse } from "../cos/nextwork_pb";
import { file_cos_nextwork } from "../cos/nextwork_pb";
import type { BriefingUpdatedEvent, GetBriefingRequest, GetBriefingResponse, OpenedBriefingRequest, OpenedBriefingResponse, PrepareBriefingsRequest, PrepareBriefingsResponse } from "../cos/briefing_pb";
import { file_cos_briefing } from "../cos/briefing_pb";
import type { GetInterruptBudgetRequest, GetInterruptBudgetResponse, InterruptionActRequest, InterruptionActResponse, InterruptionEvent, ListRecentInterruptionsRequest, ListRecentInterruptionsResponse, ListTellMeRequest, ListTellMeResponse, SetTellMeRequest, SetTellMeResponse } from "../cos/interrupt_pb";
import { file_cos_interrupt } from "../cos/interrupt_pb";
import type { DraftFocusSprintRequest, DraftFocusSprintResponse, EndFocusSprintRequest, EndFocusSprintResponse, FocusSprintEvent, GetFocusSprintRequest, GetFocusSprintResponse, StartFocusSprintRequest, StartFocusSprintResponse, UpdateFocusSprintRequest, UpdateFocusSprintResponse } from "../cos/sprint_pb";
import { file_cos_sprint } from "../cos/sprint_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file envelope/envelope.proto.
 */
export const file_envelope_envelope: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_admin_admin, file_common_common, file_research_research, file_research_progress_view, file_execution_execution, file_node_node, file_chat_chat, file_workspace_workspace, file_document_document, file_auth_auth, file_settings_settings, file_budget_budget, file_hitl_hitl, file_prompt_prompt, file_export_export, file_search_search, file_memory_memory, file_crypto_crypto, file_security_security, file_cluster_cluster, file_note_note, file_tasks_tasks, file_personalcontext_personalcontext, file_context_context, file_bgauth_bgauth, file_dag_dag, file_knowledge_knowledge, file_expertise_expertise, file_artifact_artifact, file_skill_skill, file_connector_connector, file_workflow_workflow, file_usage_usage, file_billing_billing, file_recordings_recordings, file_errors_errors, file_persona_persona, file_mantra_mantra, file_audio_audio, file_deck_deck, file_chatprompts_chatprompts, file_inbox_inbox, file_needsyou_needsyou, file_bridge_bridge, file_cos_workbatch, file_cos_nextwork, file_cos_briefing, file_cos_interrupt, file_cos_sprint]);

/**
 * MessageEnvelope is the top-level wire format for all protocol messages.
 *
 * @generated from message lvdr.v2.envelope.MessageEnvelope
 */
export type MessageEnvelope = Message<"lvdr.v2.envelope.MessageEnvelope"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: lvdr.v2.common.ErrorResponse error = 3;
   */
  error?: ErrorResponse | undefined;

  /**
   * W3C traceparent (00-traceId-spanId-flags)
   *
   * @generated from field: string trace_parent = 4;
   */
  traceParent: string;

  /**
   * Field ledger (570 = R7 error_event; 571/572 reserved for R13a/R25; 573-580 = R14 personas; 581-582 = R15 knowledge node usage; 583-584 = usage summary credits+storage; 585-586 = usage history trends; 587 = features_updated_event; 588-589 = note list-by-link; 590-593 = chat credits + credits breakdown; 594-595 = voice credits; 596-598 = auto-refill settings; 599-604 = workflow triggers-v2 catalog + manual actions; 605-606 = note delete acks; 607-609 = private home mantra; 610-613 = workflow designer turn + drift alert; 614 = chat think-harder; 615-618 = E1 workspace mount/unmount; 619-620 = E1 workspace rekey; 621-622 = E1 workspace active-context switch; 623-625 = E1 Phase 7 transfer; 626 = E1 Phase 11 workspace notification; 627-640 = E1 Phase 10 editable workspace notes + sync + edit-locks; 641-648 = E1 Phase 12 immutable document snapshots; 649-653 = note version-history snapshots; 654-655 = workspace export; 656-658 = workspace note version-history; 659-661 = research progress view v2; 662-664 = agentic chat tool-use loop; 665-666 = research defaults catalog; 667-676 = per-user MCP servers; 677-684 = audio overview / podcast; 685-686 = research title regenerate preview; 687-688 = storage breakdown; 689-690 = FE-36 DAG node content; 691-698 = COS Phase 0 task store CRUD; 699-702 = COS Phase 0b task tags+links; 703-705 = report-run progress + cancel; 706-708 = AIOS-01 personal context; 709-713 = COS-12 background execution auth; 714-727 = DECK-3 deck editor; 728-729 = deck images; 730-731 = credit ceiling; 732-733 = deck PDF; 734-735 = RT-01 realtime fan-out; 736-738 = COS-05 send grants; 739 = WFEV-04 research tags; 740-748 = TASKS-05 recurring task series; 749-750 = REC-CANCEL-01 cancel transcription; 751-752 = TASKS-08 tasks list-by-link; 753-754 = CHAT-36 chat starter prompts; 755-763 = INBOX-02b inbox control plane; 764-765 = INBOX-03 call source switch; 766-767 = chat turn inspector; 768 = CHAT-47 daily note get-or-create; 769-779 = INBOX-05c triage surface; 780-785 = INBOX-06 context card; 786-787 = CTX-02 chat interjection; 788 = WF-33 workflow run result push; 789-792 = AON-06 move connection + resume reconnect; 793-798 = INBOX-07 reply draft; 799-803 = COS-16 needs-you inbox; 804-811 = AON-11 bridge; 812-817 = INBOX-20b clear-label + self handles; 818-823 = INBOX-22 rules get/preview/set; 824-827 = INBOX-23 mailbox label + filter; 828-829 = INBOX-21 conversation thread; 830-831 = INBOX-22 dismiss proposal; 832-835 = INBOX-13a Telegram connect + status; 836-859 = MEM-09a Contexts; 860-863 = MEM-09d scope→Context; 864-869 = MEM-09c chat on Contexts; 870-872 = MEM-09e item classification; 873-887 = MEM-12 Contexts space; 888-890 = MEM-09g Workspace personality; 891-892 = MEM-09n unit links; 893-894 = MEM-10 signal pass; 895-898 = COS-14 web push wake; 899-902 = COS-27 work batches; 903-904 = COS-14b sealed openings; 905-908 = COS-25 next work; 909-911 = COS-26 attention suggestions; 912-918 = COS-28 briefings; 919-929 = COS-29 interruptions; 930-940 = HOME-03 focus sprints) NEXT_FIELD: 941
   * (Add new cases at the bottom of this oneof — bump NEXT_FIELD when you do.
   * Field numbers are NOT contiguous across sections; check the high-water
   * mark before reusing a gap.)
   *
   * @generated from oneof lvdr.v2.envelope.MessageEnvelope.payload
   */
  payload: {
    /**
     * Research (10-19, 120-129)
     *
     * @generated from field: lvdr.v2.research.CreateResearchRequest create_research_request = 10;
     */
    value: CreateResearchRequest;
    case: "createResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UpdateResearchRequest update_research_request = 11;
     */
    value: UpdateResearchRequest;
    case: "updateResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.DeleteResearchRequest delete_research_request = 12;
     */
    value: DeleteResearchRequest;
    case: "deleteResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchRequest get_research_request = 13;
     */
    value: GetResearchRequest;
    case: "getResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ListResearchRequest list_research_request = 14;
     */
    value: ListResearchRequest;
    case: "listResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SubscribeResearchRequest subscribe_research_request = 15;
     */
    value: SubscribeResearchRequest;
    case: "subscribeResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UnsubscribeResearchRequest unsubscribe_research_request = 16;
     */
    value: UnsubscribeResearchRequest;
    case: "unsubscribeResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SubscribeResearchListRequest subscribe_research_list_request = 17;
     */
    value: SubscribeResearchListRequest;
    case: "subscribeResearchListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UnsubscribeResearchListRequest unsubscribe_research_list_request = 18;
     */
    value: UnsubscribeResearchListRequest;
    case: "unsubscribeResearchListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchResponse research_response = 19;
     */
    value: ResearchResponse;
    case: "researchResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchListResponse research_list_response = 120;
     */
    value: ResearchListResponse;
    case: "researchListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchStatusUpdateEvent research_status_update_event = 121;
     */
    value: ResearchStatusUpdateEvent;
    case: "researchStatusUpdateEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchCreatedEvent research_created_event = 517;
     */
    value: ResearchCreatedEvent;
    case: "researchCreatedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchUpdatedEvent research_updated_event = 518;
     */
    value: ResearchUpdatedEvent;
    case: "researchUpdatedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GenerateSummaryRequest generate_summary_request = 122;
     */
    value: GenerateSummaryRequest;
    case: "generateSummaryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SummaryResponse summary_response = 123;
     */
    value: SummaryResponse;
    case: "summaryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchResultRequest get_research_result_request = 124;
     */
    value: GetResearchResultRequest;
    case: "getResearchResultRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchResultResponse research_result_response = 125;
     */
    value: ResearchResultResponse;
    case: "researchResultResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.MetadataRequest metadata_request = 126;
     */
    value: MetadataRequest;
    case: "metadataRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.MetadataResponse metadata_response = 127;
     */
    value: MetadataResponse;
    case: "metadataResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchAppendixRequest get_research_appendix_request = 128;
     */
    value: GetResearchAppendixRequest;
    case: "getResearchAppendixRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchAppendixResponse research_appendix_response = 129;
     */
    value: ResearchAppendixResponse;
    case: "researchAppendixResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchStatsRequest get_research_stats_request = 198;
     */
    value: GetResearchStatsRequest;
    case: "getResearchStatsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchStatsResponse research_stats_response = 199;
     */
    value: ResearchStatsResponse;
    case: "researchStatsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SetResearchReferenceRequest set_research_reference_request = 300;
     */
    value: SetResearchReferenceRequest;
    case: "setResearchReferenceRequest";
  } | {
    /**
     * Execution (20-39)
     *
     * @generated from field: lvdr.v2.execution.StartExecutionRequest start_execution_request = 20;
     */
    value: StartExecutionRequest;
    case: "startExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.PauseExecutionRequest pause_execution_request = 21;
     */
    value: PauseExecutionRequest;
    case: "pauseExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ResumeExecutionRequest resume_execution_request = 22;
     */
    value: ResumeExecutionRequest;
    case: "resumeExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.CancelExecutionRequest cancel_execution_request = 23;
     */
    value: CancelExecutionRequest;
    case: "cancelExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.RestartExecutionRequest restart_execution_request = 24;
     */
    value: RestartExecutionRequest;
    case: "restartExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.RetryExecutionRequest retry_execution_request = 25;
     */
    value: RetryExecutionRequest;
    case: "retryExecutionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ReAggregateRequest re_aggregate_request = 26;
     */
    value: ReAggregateRequest;
    case: "reAggregateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.MarkNodesForRetryRequest mark_nodes_for_retry_request = 27;
     */
    value: MarkNodesForRetryRequest;
    case: "markNodesForRetryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.GetRetryPlanRequest get_retry_plan_request = 28;
     */
    value: GetRetryPlanRequest;
    case: "getRetryPlanRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecuteRetryPlanRequest execute_retry_plan_request = 29;
     */
    value: ExecuteRetryPlanRequest;
    case: "executeRetryPlanRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionStartedEvent execution_started_event = 30;
     */
    value: ExecutionStartedEvent;
    case: "executionStartedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionProgressEvent execution_progress_event = 31;
     */
    value: ExecutionProgressEvent;
    case: "executionProgressEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionCompletedEvent execution_completed_event = 32;
     */
    value: ExecutionCompletedEvent;
    case: "executionCompletedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionFailedEvent execution_failed_event = 33;
     */
    value: ExecutionFailedEvent;
    case: "executionFailedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionPausedEvent execution_paused_event = 34;
     */
    value: ExecutionPausedEvent;
    case: "executionPausedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionCancelledEvent execution_cancelled_event = 35;
     */
    value: ExecutionCancelledEvent;
    case: "executionCancelledEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.ExecutionActivityEvent execution_activity_event = 36;
     */
    value: ExecutionActivityEvent;
    case: "executionActivityEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.MarkNodesForRetryResponse mark_nodes_for_retry_response = 37;
     */
    value: MarkNodesForRetryResponse;
    case: "markNodesForRetryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.RetryPlanResponse retry_plan_response = 38;
     */
    value: RetryPlanResponse;
    case: "retryPlanResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.DelayNotificationEvent delay_notification_event = 39;
     */
    value: DelayNotificationEvent;
    case: "delayNotificationEvent";
  } | {
    /**
     * Chat (40-54)
     *
     * @generated from field: lvdr.v2.chat.CreateChatSessionRequest create_chat_session_request = 40;
     */
    value: CreateChatSessionRequest;
    case: "createChatSessionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.SendMessageRequest send_message_request = 41;
     */
    value: SendMessageRequest;
    case: "sendMessageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.GetChatHistoryRequest get_chat_history_request = 42;
     */
    value: GetChatHistoryRequest;
    case: "getChatHistoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ListChatSessionsRequest list_chat_sessions_request = 43;
     */
    value: ListChatSessionsRequest;
    case: "listChatSessionsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.DeleteChatSessionRequest delete_chat_session_request = 44;
     */
    value: DeleteChatSessionRequest;
    case: "deleteChatSessionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.UpdateChatSessionRequest update_chat_session_request = 45;
     */
    value: UpdateChatSessionRequest;
    case: "updateChatSessionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.SubscribeChatSessionRequest subscribe_chat_session_request = 46;
     */
    value: SubscribeChatSessionRequest;
    case: "subscribeChatSessionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.UnsubscribeChatSessionRequest unsubscribe_chat_session_request = 47;
     */
    value: UnsubscribeChatSessionRequest;
    case: "unsubscribeChatSessionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatSessionResponse chat_session_response = 48;
     */
    value: ChatSessionResponse;
    case: "chatSessionResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatSessionListResponse chat_session_list_response = 49;
     */
    value: ChatSessionListResponse;
    case: "chatSessionListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatHistoryResponse chat_history_response = 50;
     */
    value: ChatHistoryResponse;
    case: "chatHistoryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatMessageEvent chat_message_event = 51;
     */
    value: ChatMessageEvent;
    case: "chatMessageEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatMessageStreamEvent chat_message_stream_event = 52;
     */
    value: ChatMessageStreamEvent;
    case: "chatMessageStreamEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatSessionUpdatedEvent chat_session_updated_event = 53;
     */
    value: ChatSessionUpdatedEvent;
    case: "chatSessionUpdatedEvent";
  } | {
    /**
     * Document (55-69, 140-147)
     *
     * @generated from field: lvdr.v2.document.UploadDocumentRequest upload_document_request = 55;
     */
    value: UploadDocumentRequest;
    case: "uploadDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DeleteDocumentRequest delete_document_request = 56;
     */
    value: DeleteDocumentRequest;
    case: "deleteDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.GetDocumentRequest get_document_request = 57;
     */
    value: GetDocumentRequest;
    case: "getDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListDocumentsRequest list_documents_request = 58;
     */
    value: ListDocumentsRequest;
    case: "listDocumentsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateDocumentMetadataRequest update_document_metadata_request = 59;
     */
    value: UpdateDocumentMetadataRequest;
    case: "updateDocumentMetadataRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SearchDocumentsRequest search_documents_request = 60;
     */
    value: SearchDocumentsRequest;
    case: "searchDocumentsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.GetDocumentContentRequest get_document_content_request = 61;
     */
    value: GetDocumentContentRequest;
    case: "getDocumentContentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SubscribeDocumentIndexingRequest subscribe_document_indexing_request = 62;
     */
    value: SubscribeDocumentIndexingRequest;
    case: "subscribeDocumentIndexingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UnsubscribeDocumentIndexingRequest unsubscribe_document_indexing_request = 63;
     */
    value: UnsubscribeDocumentIndexingRequest;
    case: "unsubscribeDocumentIndexingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentResponse document_response = 64;
     */
    value: DocumentResponse;
    case: "documentResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentListResponse document_list_response = 65;
     */
    value: DocumentListResponse;
    case: "documentListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SearchResultsResponse search_results_response = 66;
     */
    value: SearchResultsResponse;
    case: "searchResultsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentContentResponse document_content_response = 67;
     */
    value: DocumentContentResponse;
    case: "documentContentResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentIndexingProgressEvent document_indexing_progress_event = 68;
     */
    value: DocumentIndexingProgressEvent;
    case: "documentIndexingProgressEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentIndexingCompletedEvent document_indexing_completed_event = 69;
     */
    value: DocumentIndexingCompletedEvent;
    case: "documentIndexingCompletedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.document.BuildIndexRequest build_index_request = 140;
     */
    value: BuildIndexRequest;
    case: "buildIndexRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.BuildIndexResponse build_index_response = 141;
     */
    value: BuildIndexResponse;
    case: "buildIndexResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateIndexRequest update_index_request = 142;
     */
    value: UpdateIndexRequest;
    case: "updateIndexRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateIndexResponse update_index_response = 143;
     */
    value: UpdateIndexResponse;
    case: "updateIndexResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.GetIndexInfoRequest get_index_info_request = 144;
     */
    value: GetIndexInfoRequest;
    case: "getIndexInfoRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.IndexInfoResponse index_info_response = 145;
     */
    value: IndexInfoResponse;
    case: "indexInfoResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DocumentListChangedEvent document_list_changed_event = 146;
     */
    value: DocumentListChangedEvent;
    case: "documentListChangedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.document.IndexStatusChangedEvent index_status_changed_event = 147;
     */
    value: IndexStatusChangedEvent;
    case: "indexStatusChangedEvent";
  } | {
    /**
     * Auth (70-78)
     *
     * @generated from field: lvdr.v2.auth.BeginRegistrationRequest begin_registration_request = 70;
     */
    value: BeginRegistrationRequest;
    case: "beginRegistrationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.CompleteRegistrationRequest complete_registration_request = 71;
     */
    value: CompleteRegistrationRequest;
    case: "completeRegistrationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.BeginAuthenticationRequest begin_authentication_request = 72;
     */
    value: BeginAuthenticationRequest;
    case: "beginAuthenticationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.CompleteAuthenticationRequest complete_authentication_request = 73;
     */
    value: CompleteAuthenticationRequest;
    case: "completeAuthenticationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.LogoutRequest logout_request = 74;
     */
    value: LogoutRequest;
    case: "logoutRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.RegistrationOptionsResponse registration_options_response = 75;
     */
    value: RegistrationOptionsResponse;
    case: "registrationOptionsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.AuthenticationOptionsResponse authentication_options_response = 76;
     */
    value: AuthenticationOptionsResponse;
    case: "authenticationOptionsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.AuthenticationSuccessResponse authentication_success_response = 77;
     */
    value: AuthenticationSuccessResponse;
    case: "authenticationSuccessResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.LogoutResponse logout_response = 78;
     */
    value: LogoutResponse;
    case: "logoutResponse";
  } | {
    /**
     * Settings (80-83)
     *
     * @generated from field: lvdr.v2.settings.GetSettingsRequest get_settings_request = 80;
     */
    value: GetSettingsRequest;
    case: "getSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.settings.UpdateSettingsRequest update_settings_request = 81;
     */
    value: UpdateSettingsRequest;
    case: "updateSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.settings.SettingsResponse settings_response = 82;
     */
    value: SettingsResponse;
    case: "settingsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.settings.SettingsChangedEvent settings_changed_event = 83;
     */
    value: SettingsChangedEvent;
    case: "settingsChangedEvent";
  } | {
    /**
     * HITL (85-99)
     *
     * @generated from field: lvdr.v2.hitl.HITLRequestEvent hitl_request_event = 85;
     */
    value: HITLRequestEvent;
    case: "hitlRequestEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.HITLResponseMsg hitl_response_msg = 86;
     */
    value: HITLResponseMsg;
    case: "hitlResponseMsg";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.HITLTimeoutEvent hitl_timeout_event = 87;
     */
    value: HITLTimeoutEvent;
    case: "hitlTimeoutEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.HITLCancelledEvent hitl_cancelled_event = 88;
     */
    value: HITLCancelledEvent;
    case: "hitlCancelledEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.HITLPendingRequest hitl_pending_request = 89;
     */
    value: HITLPendingRequest;
    case: "hitlPendingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.HITLPendingResponse hitl_pending_response = 90;
     */
    value: HITLPendingResponse;
    case: "hitlPendingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.BudgetHITLEvent budget_hitl_event = 91;
     */
    value: BudgetHITLEvent;
    case: "budgetHitlEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.BudgetHITLResponse budget_hitl_response = 92;
     */
    value: BudgetHITLResponse;
    case: "budgetHitlResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.GuidanceRequestEvent guidance_request_event = 93;
     */
    value: GuidanceRequestEvent;
    case: "guidanceRequestEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.GuidanceResponseMsg guidance_response_msg = 94;
     */
    value: GuidanceResponseMsg;
    case: "guidanceResponseMsg";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.QualityGateEvent quality_gate_event = 95;
     */
    value: QualityGateEvent;
    case: "qualityGateEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.StopResearchEvent stop_research_event = 96;
     */
    value: StopResearchEvent;
    case: "stopResearchEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.ToolAuthRequestEvent tool_auth_request_event = 97;
     */
    value: ToolAuthRequestEvent;
    case: "toolAuthRequestEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.ToolAuthResponseMsg tool_auth_response_msg = 98;
     */
    value: ToolAuthResponseMsg;
    case: "toolAuthResponseMsg";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.OffTopicDetectionEvent off_topic_detection_event = 99;
     */
    value: OffTopicDetectionEvent;
    case: "offTopicDetectionEvent";
  } | {
    /**
     * Budget/Credits (100-105)
     *
     * @generated from field: lvdr.v2.budget.GetCreditBalanceRequest get_credit_balance_request = 100;
     */
    value: GetCreditBalanceRequest;
    case: "getCreditBalanceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditBalanceResponse credit_balance_response = 101;
     */
    value: CreditBalanceResponse;
    case: "creditBalanceResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditBalanceUpdatedEvent credit_balance_updated_event = 102;
     */
    value: CreditBalanceUpdatedEvent;
    case: "creditBalanceUpdatedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditsLowWarningEvent credits_low_warning_event = 103;
     */
    value: CreditsLowWarningEvent;
    case: "creditsLowWarningEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditsExhaustedEvent credits_exhausted_event = 104;
     */
    value: CreditsExhaustedEvent;
    case: "creditsExhaustedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditsRefilledEvent credits_refilled_event = 105;
     */
    value: CreditsRefilledEvent;
    case: "creditsRefilledEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.AutoRefillCheckoutEvent auto_refill_checkout_event = 106;
     */
    value: AutoRefillCheckoutEvent;
    case: "autoRefillCheckoutEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.TierChangedEvent tier_changed_event = 107;
     */
    value: TierChangedEvent;
    case: "tierChangedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.SeatRevokedEvent seat_revoked_event = 108;
     */
    value: SeatRevokedEvent;
    case: "seatRevokedEvent";
  } | {
    /**
     * Prompt Builder (110-115)
     *
     * @generated from field: lvdr.v2.prompt.ListProfilesRequest list_profiles_request = 110;
     */
    value: ListProfilesRequest;
    case: "listProfilesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.prompt.ListProfilesResponse list_profiles_response = 111;
     */
    value: ListProfilesResponse;
    case: "listProfilesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.prompt.SendPromptBuilderMessageRequest send_prompt_builder_message_request = 112;
     */
    value: SendPromptBuilderMessageRequest;
    case: "sendPromptBuilderMessageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.prompt.PromptBuilderMessageEvent prompt_builder_message_event = 113;
     */
    value: PromptBuilderMessageEvent;
    case: "promptBuilderMessageEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.prompt.GetTemplatesRequest get_templates_request = 114;
     */
    value: GetTemplatesRequest;
    case: "getTemplatesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.prompt.GetTemplatesResponse get_templates_response = 115;
     */
    value: GetTemplatesResponse;
    case: "getTemplatesResponse";
  } | {
    /**
     * Node (130-137)
     *
     * @generated from field: lvdr.v2.node.GetNodeRequest get_node_request = 130;
     */
    value: GetNodeRequest;
    case: "getNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.node.GetNodeTreeRequest get_node_tree_request = 131;
     */
    value: GetNodeTreeRequest;
    case: "getNodeTreeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.node.SubscribeNodesRequest subscribe_nodes_request = 132;
     */
    value: SubscribeNodesRequest;
    case: "subscribeNodesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.node.UnsubscribeNodesRequest unsubscribe_nodes_request = 133;
     */
    value: UnsubscribeNodesRequest;
    case: "unsubscribeNodesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.node.NodeResponse node_response = 134;
     */
    value: NodeResponse;
    case: "nodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.node.NodeTreeResponse node_tree_response = 135;
     */
    value: NodeTreeResponse;
    case: "nodeTreeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.node.NodeUpdateEvent node_update_event = 136;
     */
    value: NodeUpdateEvent;
    case: "nodeUpdateEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.node.NodeStatusChangedEvent node_status_changed_event = 137;
     */
    value: NodeStatusChangedEvent;
    case: "nodeStatusChangedEvent";
  } | {
    /**
     * Export (150-152)
     *
     * @generated from field: lvdr.v2.export.ExportResearchRequest export_research_request = 150;
     */
    value: ExportResearchRequest;
    case: "exportResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.export.ExportResearchResponse export_research_response = 151;
     */
    value: ExportResearchResponse;
    case: "exportResearchResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.export.ExportStatusEvent export_status_event = 152;
     */
    value: ExportStatusEvent;
    case: "exportStatusEvent";
  } | {
    /**
     * Search (153-154)
     *
     * @generated from field: lvdr.v2.search.SearchRequest search_request = 153;
     */
    value: SearchRequest;
    case: "searchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.search.SearchResponse search_response = 154;
     */
    value: SearchResponse;
    case: "searchResponse";
  } | {
    /**
     * Memory (160-195)
     *
     * @generated from field: lvdr.v2.memory.ListEntitiesRequest list_entities_request = 160;
     */
    value: ListEntitiesRequest;
    case: "listEntitiesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.EntityListResponse entity_list_response = 161;
     */
    value: EntityListResponse;
    case: "entityListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.GetEntityRequest get_entity_request = 162;
     */
    value: GetEntityRequest;
    case: "getEntityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.EntityResponse entity_response = 163;
     */
    value: EntityResponse;
    case: "entityResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.CreateEntityRequest create_entity_request = 164;
     */
    value: CreateEntityRequest;
    case: "createEntityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.UpdateEntityRequest update_entity_request = 165;
     */
    value: UpdateEntityRequest;
    case: "updateEntityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.DeleteEntityRequest delete_entity_request = 166;
     */
    value: DeleteEntityRequest;
    case: "deleteEntityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.CreateRelationRequest create_relation_request = 167;
     */
    value: CreateRelationRequest;
    case: "createRelationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.RelationResponse relation_response = 168;
     */
    value: RelationResponse;
    case: "relationResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.DeleteRelationRequest delete_relation_request = 169;
     */
    value: DeleteRelationRequest;
    case: "deleteRelationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ListTopicsRequest list_topics_request = 170;
     */
    value: ListTopicsRequest;
    case: "listTopicsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.TopicListResponse topic_list_response = 171;
     */
    value: TopicListResponse;
    case: "topicListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.CreateTopicRequest create_topic_request = 172;
     */
    value: CreateTopicRequest;
    case: "createTopicRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.TopicResponse topic_response = 173;
     */
    value: TopicResponse;
    case: "topicResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.UpdateTopicRequest update_topic_request = 174;
     */
    value: UpdateTopicRequest;
    case: "updateTopicRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.DeleteTopicRequest delete_topic_request = 175;
     */
    value: DeleteTopicRequest;
    case: "deleteTopicRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.GetGraphRequest get_graph_request = 176;
     */
    value: GetGraphRequest;
    case: "getGraphRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.GraphResponse graph_response = 177;
     */
    value: GraphResponse;
    case: "graphResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.SearchEntitiesRequest search_entities_request = 178;
     */
    value: SearchEntitiesRequest;
    case: "searchEntitiesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.SearchEntitiesResponse search_entities_response = 179;
     */
    value: SearchEntitiesResponse;
    case: "searchEntitiesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.GetReviewQueueRequest get_review_queue_request = 180;
     */
    value: GetReviewQueueRequest;
    case: "getReviewQueueRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ReviewQueueResponse review_queue_response = 181;
     */
    value: ReviewQueueResponse;
    case: "reviewQueueResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ResolveReviewRequest resolve_review_request = 182;
     */
    value: ResolveReviewRequest;
    case: "resolveReviewRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ResolveReviewResponse resolve_review_response = 183;
     */
    value: ResolveReviewResponse;
    case: "resolveReviewResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ExportMemoryRequest export_memory_request = 184;
     */
    value: ExportMemoryRequest;
    case: "exportMemoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ExportMemoryResponse export_memory_response = 185;
     */
    value: ExportMemoryResponse;
    case: "exportMemoryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ImportMemoryRequest import_memory_request = 186;
     */
    value: ImportMemoryRequest;
    case: "importMemoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ImportMemoryResponse import_memory_response = 187;
     */
    value: ImportMemoryResponse;
    case: "importMemoryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.ToggleExtractionRequest toggle_extraction_request = 188;
     */
    value: ToggleExtractionRequest;
    case: "toggleExtractionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.MemorySettingsResponse memory_settings_response = 189;
     */
    value: MemorySettingsResponse;
    case: "memorySettingsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.SubscribeMemoryRequest subscribe_memory_request = 190;
     */
    value: SubscribeMemoryRequest;
    case: "subscribeMemoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.UnsubscribeMemoryRequest unsubscribe_memory_request = 191;
     */
    value: UnsubscribeMemoryRequest;
    case: "unsubscribeMemoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.MemoryEntityChangedEvent memory_entity_changed_event = 192;
     */
    value: MemoryEntityChangedEvent;
    case: "memoryEntityChangedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.MemoryReviewAvailableEvent memory_review_available_event = 193;
     */
    value: MemoryReviewAvailableEvent;
    case: "memoryReviewAvailableEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.GetMemorySettingsRequest get_memory_settings_request = 194;
     */
    value: GetMemorySettingsRequest;
    case: "getMemorySettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.UpdateMemorySettingsRequest update_memory_settings_request = 195;
     */
    value: UpdateMemorySettingsRequest;
    case: "updateMemorySettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.BatchApproveReviewsRequest batch_approve_reviews_request = 196;
     */
    value: BatchApproveReviewsRequest;
    case: "batchApproveReviewsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.memory.BatchApproveReviewsResponse batch_approve_reviews_response = 197;
     */
    value: BatchApproveReviewsResponse;
    case: "batchApproveReviewsResponse";
  } | {
    /**
     * Failure catalog (210-213)
     *
     * @generated from field: lvdr.v2.execution.DismissResearchErrorRequest dismiss_research_error_request = 210;
     */
    value: DismissResearchErrorRequest;
    case: "dismissResearchErrorRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.DismissResearchErrorResponse dismiss_research_error_response = 211;
     */
    value: DismissResearchErrorResponse;
    case: "dismissResearchErrorResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.UpdateResearchBudgetRequest update_research_budget_request = 212;
     */
    value: UpdateResearchBudgetRequest;
    case: "updateResearchBudgetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.UpdateResearchBudgetResponse update_research_budget_response = 213;
     */
    value: UpdateResearchBudgetResponse;
    case: "updateResearchBudgetResponse";
  } | {
    /**
     * Wrap-up (214-215)
     *
     * @generated from field: lvdr.v2.hitl.WrapUpResearchMsg wrap_up_research_msg = 214;
     */
    value: WrapUpResearchMsg;
    case: "wrapUpResearchMsg";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.ResearchWrappingUpEvent research_wrapping_up_event = 215;
     */
    value: ResearchWrappingUpEvent;
    case: "researchWrappingUpEvent";
  } | {
    /**
     * Enricher clarification (260-261)
     *
     * @generated from field: lvdr.v2.hitl.EnricherClarificationRequestEvent enricher_clarification_request_event = 260;
     */
    value: EnricherClarificationRequestEvent;
    case: "enricherClarificationRequestEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.EnricherClarificationResponseMsg enricher_clarification_response_msg = 261;
     */
    value: EnricherClarificationResponseMsg;
    case: "enricherClarificationResponseMsg";
  } | {
    /**
     * Ignore failed nodes (216-217)
     *
     * @generated from field: lvdr.v2.execution.IgnoreFailedNodesRequest ignore_failed_nodes_request = 216;
     */
    value: IgnoreFailedNodesRequest;
    case: "ignoreFailedNodesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.IgnoreFailedNodesResponse ignore_failed_nodes_response = 217;
     */
    value: IgnoreFailedNodesResponse;
    case: "ignoreFailedNodesResponse";
  } | {
    /**
     * Document - Collections & Linking (220-229)
     *
     * @generated from field: lvdr.v2.document.CreateCollectionRequest create_collection_request = 220;
     */
    value: CreateCollectionRequest;
    case: "createCollectionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateCollectionRequest update_collection_request = 221;
     */
    value: UpdateCollectionRequest;
    case: "updateCollectionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DeleteCollectionRequest delete_collection_request = 222;
     */
    value: DeleteCollectionRequest;
    case: "deleteCollectionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListCollectionsRequest list_collections_request = 223;
     */
    value: ListCollectionsRequest;
    case: "listCollectionsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.CollectionListResponse collection_list_response = 224;
     */
    value: CollectionListResponse;
    case: "collectionListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.CollectionResponse collection_response = 225;
     */
    value: CollectionResponse;
    case: "collectionResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.LinkDocumentRequest link_document_request = 226;
     */
    value: LinkDocumentRequest;
    case: "linkDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UnlinkDocumentRequest unlink_document_request = 227;
     */
    value: UnlinkDocumentRequest;
    case: "unlinkDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListResearchDocumentsRequest list_research_documents_request = 228;
     */
    value: ListResearchDocumentsRequest;
    case: "listResearchDocumentsRequest";
  } | {
    /**
     * Crypto (230-233)
     *
     * @generated from field: lvdr.v2.crypto.CryptoUnlockChallenge crypto_unlock_challenge = 230;
     */
    value: CryptoUnlockChallenge;
    case: "cryptoUnlockChallenge";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.CryptoUnlockResponse crypto_unlock_response = 231;
     */
    value: CryptoUnlockResponse;
    case: "cryptoUnlockResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.CryptoSessionUnlocked crypto_session_unlocked = 232;
     */
    value: CryptoSessionUnlocked;
    case: "cryptoSessionUnlocked";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.CryptoSessionKill crypto_session_kill = 233;
     */
    value: CryptoSessionKill;
    case: "cryptoSessionKill";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.RotationStatusEvent rotation_status_event = 234;
     */
    value: RotationStatusEvent;
    case: "rotationStatusEvent";
  } | {
    /**
     * Security (240-244)
     *
     * @generated from field: lvdr.v2.security.SecuritySummaryRequest security_summary_request = 240;
     */
    value: SecuritySummaryRequest;
    case: "securitySummaryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SecuritySummary security_summary = 241;
     */
    value: SecuritySummary;
    case: "securitySummary";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SecurityAlert security_alert = 242;
     */
    value: SecurityAlert;
    case: "securityAlert";
  } | {
    /**
     * @generated from field: lvdr.v2.security.AccessRequestEvent access_request_event = 243;
     */
    value: AccessRequestEvent;
    case: "accessRequestEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.security.AccessDecisionEvent access_decision_event = 244;
     */
    value: AccessDecisionEvent;
    case: "accessDecisionEvent";
  } | {
    /**
     * Cluster coordination (250-251)
     *
     * @generated from field: lvdr.v2.cluster.SessionRedirect session_redirect = 250;
     */
    value: SessionRedirect;
    case: "sessionRedirect";
  } | {
    /**
     * @generated from field: lvdr.v2.cluster.DrainNotice drain_notice = 251;
     */
    value: DrainNotice;
    case: "drainNotice";
  } | {
    /**
     * Note (270-289)
     *
     * @generated from field: lvdr.v2.note.CreateNoteRequest create_note_request = 270;
     */
    value: CreateNoteRequest;
    case: "createNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.GetNoteRequest get_note_request = 271;
     */
    value: GetNoteRequest;
    case: "getNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.UpdateNoteRequest update_note_request = 272;
     */
    value: UpdateNoteRequest;
    case: "updateNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.DeleteNoteRequest delete_note_request = 273;
     */
    value: DeleteNoteRequest;
    case: "deleteNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.ListNotesRequest list_notes_request = 274;
     */
    value: ListNotesRequest;
    case: "listNotesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteResponse note_response = 275;
     */
    value: NoteResponse;
    case: "noteResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteListResponse note_list_response = 276;
     */
    value: NoteListResponse;
    case: "noteListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.CreateNoteFolderRequest create_note_folder_request = 277;
     */
    value: CreateNoteFolderRequest;
    case: "createNoteFolderRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.UpdateNoteFolderRequest update_note_folder_request = 278;
     */
    value: UpdateNoteFolderRequest;
    case: "updateNoteFolderRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.DeleteNoteFolderRequest delete_note_folder_request = 279;
     */
    value: DeleteNoteFolderRequest;
    case: "deleteNoteFolderRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.ListNoteFoldersRequest list_note_folders_request = 280;
     */
    value: ListNoteFoldersRequest;
    case: "listNoteFoldersRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteFolderResponse note_folder_response = 281;
     */
    value: NoteFolderResponse;
    case: "noteFolderResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteFolderListResponse note_folder_list_response = 282;
     */
    value: NoteFolderListResponse;
    case: "noteFolderListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.LinkNoteRequest link_note_request = 283;
     */
    value: LinkNoteRequest;
    case: "linkNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.UnlinkNoteRequest unlink_note_request = 284;
     */
    value: UnlinkNoteRequest;
    case: "unlinkNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteAIRequest note_ai_request = 285;
     */
    value: NoteAIRequest;
    case: "noteAiRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteAIResponse note_ai_response = 286;
     */
    value: NoteAIResponse;
    case: "noteAiResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteResearchRequest note_research_request = 287;
     */
    value: NoteResearchRequest;
    case: "noteResearchRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteResearchResponse note_research_response = 288;
     */
    value: NoteResearchResponse;
    case: "noteResearchResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.SearchNoteEntitiesRequest search_note_entities_request = 289;
     */
    value: SearchNoteEntitiesRequest;
    case: "searchNoteEntitiesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.SearchNoteEntitiesResponse search_note_entities_response = 290;
     */
    value: SearchNoteEntitiesResponse;
    case: "searchNoteEntitiesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.ListNotesByLinkRequest list_notes_by_link_request = 588;
     */
    value: ListNotesByLinkRequest;
    case: "listNotesByLinkRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.ListNotesByLinkResponse list_notes_by_link_response = 589;
     */
    value: ListNotesByLinkResponse;
    case: "listNotesByLinkResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.DeleteNoteResponse delete_note_response = 605;
     */
    value: DeleteNoteResponse;
    case: "deleteNoteResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.DeleteNoteFolderResponse delete_note_folder_response = 606;
     */
    value: DeleteNoteFolderResponse;
    case: "deleteNoteFolderResponse";
  } | {
    /**
     * Start Over (301-302)
     *
     * @generated from field: lvdr.v2.execution.StartOverRequest start_over_request = 301;
     */
    value: StartOverRequest;
    case: "startOverRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.StartOverResponse start_over_response = 302;
     */
    value: StartOverResponse;
    case: "startOverResponse";
  } | {
    /**
     * DAG Engine (310-325)
     *
     * @generated from field: lvdr.v2.dag.SubscribeDAGRequest subscribe_dag_request = 310;
     */
    value: SubscribeDAGRequest;
    case: "subscribeDagRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.UnsubscribeDAGRequest unsubscribe_dag_request = 311;
     */
    value: UnsubscribeDAGRequest;
    case: "unsubscribeDagRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.DAGGraphEvent dag_graph_event = 312;
     */
    value: DAGGraphEvent;
    case: "dagGraphEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.RetryNodeRequest retry_node_request = 313;
     */
    value: RetryNodeRequest;
    case: "retryNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.InvalidateNodeRequest invalidate_node_request = 314;
     */
    value: InvalidateNodeRequest;
    case: "invalidateNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.IgnoreNodeRequest ignore_node_request = 315;
     */
    value: IgnoreNodeRequest;
    case: "ignoreNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.PauseGraphRequest pause_graph_request = 316;
     */
    value: PauseGraphRequest;
    case: "pauseGraphRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.ResumeGraphRequest resume_graph_request = 317;
     */
    value: ResumeGraphRequest;
    case: "resumeGraphRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGNodeRequest get_dag_node_request = 318;
     */
    value: GetDAGNodeRequest;
    case: "getDagNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGNodeResponse get_dag_node_response = 319;
     */
    value: GetDAGNodeResponse;
    case: "getDagNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGNodeChannelRequest get_dag_node_channel_request = 320;
     */
    value: GetDAGNodeChannelRequest;
    case: "getDagNodeChannelRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGNodeChannelResponse get_dag_node_channel_response = 321;
     */
    value: GetDAGNodeChannelResponse;
    case: "getDagNodeChannelResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGGraphRequest get_dag_graph_request = 322;
     */
    value: GetDAGGraphRequest;
    case: "getDagGraphRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGGraphResponse get_dag_graph_response = 323;
     */
    value: GetDAGGraphResponse;
    case: "getDagGraphResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetCachedPageRequest get_cached_page_request = 324;
     */
    value: GetCachedPageRequest;
    case: "getCachedPageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetCachedPageResponse get_cached_page_response = 325;
     */
    value: GetCachedPageResponse;
    case: "getCachedPageResponse";
  } | {
    /**
     * Knowledge Search (326-338)
     *
     * @generated from field: lvdr.v2.knowledge.SearchKnowledgeRequest search_knowledge_request = 326;
     */
    value: SearchKnowledgeRequest;
    case: "searchKnowledgeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.SearchKnowledgeResponse search_knowledge_response = 327;
     */
    value: SearchKnowledgeResponse;
    case: "searchKnowledgeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.BrowseKnowledgeRequest browse_knowledge_request = 328;
     */
    value: BrowseKnowledgeRequest;
    case: "browseKnowledgeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.BrowseKnowledgeResponse browse_knowledge_response = 329;
     */
    value: BrowseKnowledgeResponse;
    case: "browseKnowledgeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.ListKnowledgeGapsRequest list_knowledge_gaps_request = 330;
     */
    value: ListKnowledgeGapsRequest;
    case: "listKnowledgeGapsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.ListKnowledgeGapsResponse list_knowledge_gaps_response = 331;
     */
    value: ListKnowledgeGapsResponse;
    case: "listKnowledgeGapsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.GetKnowledgeNodeRequest get_knowledge_node_request = 332;
     */
    value: GetKnowledgeNodeRequest;
    case: "getKnowledgeNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.GetKnowledgeNodeResponse get_knowledge_node_response = 333;
     */
    value: GetKnowledgeNodeResponse;
    case: "getKnowledgeNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.UpdateKnowledgeNodeRequest update_knowledge_node_request = 334;
     */
    value: UpdateKnowledgeNodeRequest;
    case: "updateKnowledgeNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.UpdateKnowledgeNodeResponse update_knowledge_node_response = 335;
     */
    value: UpdateKnowledgeNodeResponse;
    case: "updateKnowledgeNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.DeleteKnowledgeNodeRequest delete_knowledge_node_request = 336;
     */
    value: DeleteKnowledgeNodeRequest;
    case: "deleteKnowledgeNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.DeleteKnowledgeNodeResponse delete_knowledge_node_response = 337;
     */
    value: DeleteKnowledgeNodeResponse;
    case: "deleteKnowledgeNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.KnowledgeSearchProgressEvent knowledge_search_progress_event = 338;
     */
    value: KnowledgeSearchProgressEvent;
    case: "knowledgeSearchProgressEvent";
  } | {
    /**
     * Research Strategy Configuration (339-344)
     *
     * @generated from field: lvdr.v2.research.ResearchConfigRequest research_config_request = 339;
     */
    value: ResearchConfigRequest;
    case: "researchConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchConfigResponse research_config_response = 340;
     */
    value: ResearchConfigResponse;
    case: "researchConfigResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ConfigGoRequest config_go_request = 341;
     */
    value: ConfigGoRequest;
    case: "configGoRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ConfigGoResponse config_go_response = 342;
     */
    value: ConfigGoResponse;
    case: "configGoResponse";
  } | {
    /**
     * Field 343 was GenerateOutputFormRequest (default-stub handler, no live
     * dispatch). Repurposed in place to GenerateReportRequest as part of the
     * report library work; see docs/plans/2026-05-13-report-library-and-research-passes-design.md.
     *
     * @generated from field: lvdr.v2.research.GenerateReportRequest generate_report_request = 343;
     */
    value: GenerateReportRequest;
    case: "generateReportRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GenerateReportResponse generate_report_response = 344;
     */
    value: GenerateReportResponse;
    case: "generateReportResponse";
  } | {
    /**
     * Document - Scopes, Tags & Retry (345-363)
     *
     * @generated from field: lvdr.v2.document.CreateScopeRequest create_scope_request = 345;
     */
    value: CreateScopeRequest;
    case: "createScopeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateScopeRequest update_scope_request = 346;
     */
    value: UpdateScopeRequest;
    case: "updateScopeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DeleteScopeRequest delete_scope_request = 347;
     */
    value: DeleteScopeRequest;
    case: "deleteScopeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListScopesRequest list_scopes_request = 348;
     */
    value: ListScopesRequest;
    case: "listScopesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeListResponse scope_list_response = 349;
     */
    value: ScopeListResponse;
    case: "scopeListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeResponse scope_response = 350;
     */
    value: ScopeResponse;
    case: "scopeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.GetScopeTreeRequest get_scope_tree_request = 351;
     */
    value: GetScopeTreeRequest;
    case: "getScopeTreeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.GetScopeTreeResponse get_scope_tree_response = 352;
     */
    value: GetScopeTreeResponse;
    case: "getScopeTreeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.AttachResearchScopeRequest attach_research_scope_request = 353;
     */
    value: AttachResearchScopeRequest;
    case: "attachResearchScopeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.DetachResearchScopeRequest detach_research_scope_request = 354;
     */
    value: DetachResearchScopeRequest;
    case: "detachResearchScopeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListResearchScopesRequest list_research_scopes_request = 355;
     */
    value: ListResearchScopesRequest;
    case: "listResearchScopesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ResearchScopeListResponse research_scope_list_response = 356;
     */
    value: ResearchScopeListResponse;
    case: "researchScopeListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ReorderResearchScopesRequest reorder_research_scopes_request = 357;
     */
    value: ReorderResearchScopesRequest;
    case: "reorderResearchScopesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListTagVocabularyRequest list_tag_vocabulary_request = 358;
     */
    value: ListTagVocabularyRequest;
    case: "listTagVocabularyRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ListTagVocabularyResponse list_tag_vocabulary_response = 359;
     */
    value: ListTagVocabularyResponse;
    case: "listTagVocabularyResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SuggestTagsRequest suggest_tags_request = 360;
     */
    value: SuggestTagsRequest;
    case: "suggestTagsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SuggestTagsResponse suggest_tags_response = 361;
     */
    value: SuggestTagsResponse;
    case: "suggestTagsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.UpdateDocumentTagsRequest update_document_tags_request = 362;
     */
    value: UpdateDocumentTagsRequest;
    case: "updateDocumentTagsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.RetryDocumentRequest retry_document_request = 363;
     */
    value: RetryDocumentRequest;
    case: "retryDocumentRequest";
  } | {
    /**
     * Research-scoped Knowledge (364-371) — cascade extraction output per research
     *
     * @generated from field: lvdr.v2.knowledge.SearchResearchContextRequest search_research_context_request = 364;
     */
    value: SearchResearchContextRequest;
    case: "searchResearchContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.SearchResearchContextResponse search_research_context_response = 365;
     */
    value: SearchResearchContextResponse;
    case: "searchResearchContextResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.BrowseResearchContextRequest browse_research_context_request = 366;
     */
    value: BrowseResearchContextRequest;
    case: "browseResearchContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.BrowseResearchContextResponse browse_research_context_response = 367;
     */
    value: BrowseResearchContextResponse;
    case: "browseResearchContextResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.ResearchNodeDetailRequest research_node_detail_request = 368;
     */
    value: ResearchNodeDetailRequest;
    case: "researchNodeDetailRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.ResearchNodeDetailResponse research_node_detail_response = 369;
     */
    value: ResearchNodeDetailResponse;
    case: "researchNodeDetailResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.PromoteResearchContextRequest promote_research_context_request = 370;
     */
    value: PromoteResearchContextRequest;
    case: "promoteResearchContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.PromoteResearchContextResponse promote_research_context_response = 371;
     */
    value: PromoteResearchContextResponse;
    case: "promoteResearchContextResponse";
  } | {
    /**
     * Connection (200-201)
     *
     * @generated from field: lvdr.v2.envelope.Ping ping = 200;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: lvdr.v2.envelope.Pong pong = 201;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * Wave 1 HTTP→WS migration — user-scoped profile endpoints (400-415)
     *
     * @generated from field: lvdr.v2.settings.GetUserSettingsRequest get_user_settings_request = 400;
     */
    value: GetUserSettingsRequest;
    case: "getUserSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.settings.UpdateUserSettingsRequest update_user_settings_request = 401;
     */
    value: UpdateUserSettingsRequest;
    case: "updateUserSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.settings.UserSettingsResponse user_settings_response = 402;
     */
    value: UserSettingsResponse;
    case: "userSettingsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.expertise.GetExpertiseRequest get_expertise_request = 403;
     */
    value: GetExpertiseRequest;
    case: "getExpertiseRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.expertise.UpdateExpertiseRequest update_expertise_request = 404;
     */
    value: UpdateExpertiseRequest;
    case: "updateExpertiseRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.expertise.ExpertiseResponse expertise_response = 405;
     */
    value: ExpertiseResponse;
    case: "expertiseResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.expertise.ListKnownTopicsRequest list_known_topics_request = 406;
     */
    value: ListKnownTopicsRequest;
    case: "listKnownTopicsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.expertise.KnownTopicsResponse known_topics_response = 407;
     */
    value: KnownTopicsResponse;
    case: "knownTopicsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.GetKeyRotationStatusRequest get_key_rotation_status_request = 408;
     */
    value: GetKeyRotationStatusRequest;
    case: "getKeyRotationStatusRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.crypto.KeyRotationStatusResponse key_rotation_status_response = 409;
     */
    value: KeyRotationStatusResponse;
    case: "keyRotationStatusResponse";
  } | {
    /**
     * Wave 2 HTTP→WS migration — per-research actions (410-430)
     *
     * @generated from field: lvdr.v2.research.SetResearchPriorityRequest set_research_priority_request = 410;
     */
    value: SetResearchPriorityRequest;
    case: "setResearchPriorityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SetResearchPriorityResponse set_research_priority_response = 411;
     */
    value: SetResearchPriorityResponse;
    case: "setResearchPriorityResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.artifact.ListArtifactsRequest list_artifacts_request = 412;
     */
    value: ListArtifactsRequest;
    case: "listArtifactsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.artifact.ArtifactListResponse artifact_list_response = 413;
     */
    value: ArtifactListResponse;
    case: "artifactListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.ListAvailableEnhancementsRequest list_available_enhancements_request = 414;
     */
    value: ListAvailableEnhancementsRequest;
    case: "listAvailableEnhancementsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.ListAvailableEnhancementsResponse list_available_enhancements_response = 415;
     */
    value: ListAvailableEnhancementsResponse;
    case: "listAvailableEnhancementsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.RunEnhancementRequest run_enhancement_request = 416;
     */
    value: RunEnhancementRequest;
    case: "runEnhancementRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.RunEnhancementResponse run_enhancement_response = 417;
     */
    value: RunEnhancementResponse;
    case: "runEnhancementResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.RevealNodeRequest reveal_node_request = 418;
     */
    value: RevealNodeRequest;
    case: "revealNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.RevealNodeResponse reveal_node_response = 419;
     */
    value: RevealNodeResponse;
    case: "revealNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ListMyAccessRequestsRequest list_my_access_requests_request = 420;
     */
    value: ListMyAccessRequestsRequest;
    case: "listMyAccessRequestsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ListAccessRequestsRequest list_access_requests_request = 421;
     */
    value: ListAccessRequestsRequest;
    case: "listAccessRequestsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.AccessGrantListResponse access_grant_list_response = 422;
     */
    value: AccessGrantListResponse;
    case: "accessGrantListResponse";
  } | {
    /**
     * Wave 3a HTTP→WS migration — connector credential management (423-433)
     *
     * @generated from field: lvdr.v2.connector.ListConnectorsRequest list_connectors_request = 423;
     */
    value: ListConnectorsRequest;
    case: "listConnectorsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.ListConnectorsResponse list_connectors_response = 424;
     */
    value: ListConnectorsResponse;
    case: "listConnectorsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.GetConnectorRequest get_connector_request = 425;
     */
    value: GetConnectorRequest;
    case: "getConnectorRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.ConnectorResponse connector_response = 426;
     */
    value: ConnectorResponse;
    case: "connectorResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.StoreConnectorAuthRequest store_connector_auth_request = 427;
     */
    value: StoreConnectorAuthRequest;
    case: "storeConnectorAuthRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.RevokeConnectorAuthRequest revoke_connector_auth_request = 428;
     */
    value: RevokeConnectorAuthRequest;
    case: "revokeConnectorAuthRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.ConnectorAuthResponse connector_auth_response = 429;
     */
    value: ConnectorAuthResponse;
    case: "connectorAuthResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.GetConnectorAuthStatusRequest get_connector_auth_status_request = 430;
     */
    value: GetConnectorAuthStatusRequest;
    case: "getConnectorAuthStatusRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.ConnectorAuthStatusResponse connector_auth_status_response = 431;
     */
    value: ConnectorAuthStatusResponse;
    case: "connectorAuthStatusResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.TestConnectorRequest test_connector_request = 432;
     */
    value: TestConnectorRequest;
    case: "testConnectorRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.TestConnectorResponse test_connector_response = 433;
     */
    value: TestConnectorResponse;
    case: "testConnectorResponse";
  } | {
    /**
     * Wave 3b HTTP→WS migration — per-user skill catalog (434-444)
     *
     * @generated from field: lvdr.v2.skill.ListSkillsRequest list_skills_request = 434;
     */
    value: ListSkillsRequest;
    case: "listSkillsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.ListSkillsResponse list_skills_response = 435;
     */
    value: ListSkillsResponse;
    case: "listSkillsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.CreateSkillRequest create_skill_request = 436;
     */
    value: CreateSkillRequest;
    case: "createSkillRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.UpdateSkillRequest update_skill_request = 437;
     */
    value: UpdateSkillRequest;
    case: "updateSkillRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.DeleteSkillRequest delete_skill_request = 438;
     */
    value: DeleteSkillRequest;
    case: "deleteSkillRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.DeleteSkillResponse delete_skill_response = 439;
     */
    value: DeleteSkillResponse;
    case: "deleteSkillResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.SkillResponse skill_response = 440;
     */
    value: SkillResponse;
    case: "skillResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.UpdateSkillPrefsRequest update_skill_prefs_request = 441;
     */
    value: UpdateSkillPrefsRequest;
    case: "updateSkillPrefsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.SkillPrefsResponse skill_prefs_response = 442;
     */
    value: SkillPrefsResponse;
    case: "skillPrefsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.GenerateSkillRequest generate_skill_request = 443;
     */
    value: GenerateSkillRequest;
    case: "generateSkillRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.skill.GenerateSkillResponse generate_skill_response = 444;
     */
    value: GenerateSkillResponse;
    case: "generateSkillResponse";
  } | {
    /**
     * Wave 3c.1 HTTP→WS migration — workflow main CRUD (445-470)
     *
     * @generated from field: lvdr.v2.workflow.CreateWorkflowRequest create_workflow_request = 445;
     */
    value: CreateWorkflowRequest;
    case: "createWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.CreateWorkflowResponse create_workflow_response = 446;
     */
    value: CreateWorkflowResponse;
    case: "createWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowsRequest list_workflows_request = 447;
     */
    value: ListWorkflowsRequest;
    case: "listWorkflowsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowsResponse list_workflows_response = 448;
     */
    value: ListWorkflowsResponse;
    case: "listWorkflowsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.GetWorkflowRequest get_workflow_request = 449;
     */
    value: GetWorkflowRequest;
    case: "getWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.WorkflowResponse workflow_response = 450;
     */
    value: WorkflowResponse;
    case: "workflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.UpdateWorkflowRequest update_workflow_request = 451;
     */
    value: UpdateWorkflowRequest;
    case: "updateWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.UpdateWorkflowResponse update_workflow_response = 452;
     */
    value: UpdateWorkflowResponse;
    case: "updateWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowRequest delete_workflow_request = 453;
     */
    value: DeleteWorkflowRequest;
    case: "deleteWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowResponse delete_workflow_response = 454;
     */
    value: DeleteWorkflowResponse;
    case: "deleteWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.RunWorkflowRequest run_workflow_request = 455;
     */
    value: RunWorkflowRequest;
    case: "runWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.RunWorkflowResponse run_workflow_response = 456;
     */
    value: RunWorkflowResponse;
    case: "runWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.PublishWorkflowRequest publish_workflow_request = 457;
     */
    value: PublishWorkflowRequest;
    case: "publishWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.PublishWorkflowResponse publish_workflow_response = 458;
     */
    value: PublishWorkflowResponse;
    case: "publishWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeployWorkflowRequest deploy_workflow_request = 459;
     */
    value: DeployWorkflowRequest;
    case: "deployWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeployWorkflowResponse deploy_workflow_response = 460;
     */
    value: DeployWorkflowResponse;
    case: "deployWorkflowResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowDraftRequest delete_workflow_draft_request = 461;
     */
    value: DeleteWorkflowDraftRequest;
    case: "deleteWorkflowDraftRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowDraftResponse delete_workflow_draft_response = 462;
     */
    value: DeleteWorkflowDraftResponse;
    case: "deleteWorkflowDraftResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ApproveWorkflowStepRequest approve_workflow_step_request = 463;
     */
    value: ApproveWorkflowStepRequest;
    case: "approveWorkflowStepRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ApproveWorkflowStepResponse approve_workflow_step_response = 464;
     */
    value: ApproveWorkflowStepResponse;
    case: "approveWorkflowStepResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowInstancesRequest list_workflow_instances_request = 465;
     */
    value: ListWorkflowInstancesRequest;
    case: "listWorkflowInstancesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowInstancesResponse list_workflow_instances_response = 466;
     */
    value: ListWorkflowInstancesResponse;
    case: "listWorkflowInstancesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.GetWorkflowInstanceRequest get_workflow_instance_request = 467;
     */
    value: GetWorkflowInstanceRequest;
    case: "getWorkflowInstanceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.WorkflowInstanceResponse workflow_instance_response = 468;
     */
    value: WorkflowInstanceResponse;
    case: "workflowInstanceResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.CancelWorkflowInstanceRequest cancel_workflow_instance_request = 469;
     */
    value: CancelWorkflowInstanceRequest;
    case: "cancelWorkflowInstanceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.CancelWorkflowInstanceResponse cancel_workflow_instance_response = 470;
     */
    value: CancelWorkflowInstanceResponse;
    case: "cancelWorkflowInstanceResponse";
  } | {
    /**
     * Wave 3c.2 HTTP→WS migration — triggers + templates + validate (471-492)
     *
     * @generated from field: lvdr.v2.workflow.ListTriggersRequest list_triggers_request = 471;
     */
    value: ListTriggersRequest;
    case: "listTriggersRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListTriggersResponse list_triggers_response = 472;
     */
    value: ListTriggersResponse;
    case: "listTriggersResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.CreateTriggerRequest create_trigger_request = 473;
     */
    value: CreateTriggerRequest;
    case: "createTriggerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.TriggerResponse trigger_response = 474;
     */
    value: TriggerResponse;
    case: "triggerResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.UpdateTriggerRequest update_trigger_request = 475;
     */
    value: UpdateTriggerRequest;
    case: "updateTriggerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteTriggerRequest delete_trigger_request = 476;
     */
    value: DeleteTriggerRequest;
    case: "deleteTriggerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteTriggerResponse delete_trigger_response = 477;
     */
    value: DeleteTriggerResponse;
    case: "deleteTriggerResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.GetTriggerHistoryRequest get_trigger_history_request = 478;
     */
    value: GetTriggerHistoryRequest;
    case: "getTriggerHistoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.TriggerHistoryResponse trigger_history_response = 479;
     */
    value: TriggerHistoryResponse;
    case: "triggerHistoryResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowTemplatesRequest list_workflow_templates_request = 480;
     */
    value: ListWorkflowTemplatesRequest;
    case: "listWorkflowTemplatesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ListWorkflowTemplatesResponse list_workflow_templates_response = 481;
     */
    value: ListWorkflowTemplatesResponse;
    case: "listWorkflowTemplatesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.InstantiateWorkflowTemplateRequest instantiate_workflow_template_request = 482;
     */
    value: InstantiateWorkflowTemplateRequest;
    case: "instantiateWorkflowTemplateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.InstantiateWorkflowTemplateResponse instantiate_workflow_template_response = 483;
     */
    value: InstantiateWorkflowTemplateResponse;
    case: "instantiateWorkflowTemplateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowTemplateRequest delete_workflow_template_request = 484;
     */
    value: DeleteWorkflowTemplateRequest;
    case: "deleteWorkflowTemplateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DeleteWorkflowTemplateResponse delete_workflow_template_response = 485;
     */
    value: DeleteWorkflowTemplateResponse;
    case: "deleteWorkflowTemplateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.SaveWorkflowAsTemplateRequest save_workflow_as_template_request = 486;
     */
    value: SaveWorkflowAsTemplateRequest;
    case: "saveWorkflowAsTemplateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.SaveWorkflowAsTemplateResponse save_workflow_as_template_response = 487;
     */
    value: SaveWorkflowAsTemplateResponse;
    case: "saveWorkflowAsTemplateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ValidateWorkflowRequest validate_workflow_request = 488;
     */
    value: ValidateWorkflowRequest;
    case: "validateWorkflowRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ValidateWorkflowResponse validate_workflow_response = 489;
     */
    value: ValidateWorkflowResponse;
    case: "validateWorkflowResponse";
  } | {
    /**
     * Wave 4 HTTP→WS migration — security config + audit (490-517)
     *
     * @generated from field: lvdr.v2.security.SubmitSourceFeedbackRequest submit_source_feedback_request = 490;
     */
    value: SubmitSourceFeedbackRequest;
    case: "submitSourceFeedbackRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SubmitSourceFeedbackResponse submit_source_feedback_response = 491;
     */
    value: SubmitSourceFeedbackResponse;
    case: "submitSourceFeedbackResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.UpdateDomainReputationRequest update_domain_reputation_request = 492;
     */
    value: UpdateDomainReputationRequest;
    case: "updateDomainReputationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.UpdateDomainReputationResponse update_domain_reputation_response = 493;
     */
    value: UpdateDomainReputationResponse;
    case: "updateDomainReputationResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.GetThresholdConfigRequest get_threshold_config_request = 494;
     */
    value: GetThresholdConfigRequest;
    case: "getThresholdConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.UpdateThresholdConfigRequest update_threshold_config_request = 495;
     */
    value: UpdateThresholdConfigRequest;
    case: "updateThresholdConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ThresholdConfigResponse threshold_config_response = 496;
     */
    value: ThresholdConfigResponse;
    case: "thresholdConfigResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.GetModelTrustConfigRequest get_model_trust_config_request = 497;
     */
    value: GetModelTrustConfigRequest;
    case: "getModelTrustConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.UpdateModelTrustConfigRequest update_model_trust_config_request = 498;
     */
    value: UpdateModelTrustConfigRequest;
    case: "updateModelTrustConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ModelTrustConfigResponse model_trust_config_response = 499;
     */
    value: ModelTrustConfigResponse;
    case: "modelTrustConfigResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ListAuditEventsRequest list_audit_events_request = 500;
     */
    value: ListAuditEventsRequest;
    case: "listAuditEventsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.ListAuditEventsResponse list_audit_events_response = 501;
     */
    value: ListAuditEventsResponse;
    case: "listAuditEventsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.GetAuditEventRequest get_audit_event_request = 502;
     */
    value: GetAuditEventRequest;
    case: "getAuditEventRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.GetAuditEventResponse get_audit_event_response = 503;
     */
    value: GetAuditEventResponse;
    case: "getAuditEventResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SubmitAuditFeedbackRequest submit_audit_feedback_request = 504;
     */
    value: SubmitAuditFeedbackRequest;
    case: "submitAuditFeedbackRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SubmitAuditFeedbackResponse submit_audit_feedback_response = 505;
     */
    value: SubmitAuditFeedbackResponse;
    case: "submitAuditFeedbackResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SimulateSecurityDecisionRequest simulate_security_decision_request = 506;
     */
    value: SimulateSecurityDecisionRequest;
    case: "simulateSecurityDecisionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.security.SimulateSecurityDecisionResponse simulate_security_decision_response = 507;
     */
    value: SimulateSecurityDecisionResponse;
    case: "simulateSecurityDecisionResponse";
  } | {
    /**
     * Wave 5 HTTP→WS migration — usage + costs + billing balance (508-515)
     *
     * @generated from field: lvdr.v2.usage.GetHourlyUsageRequest get_hourly_usage_request = 508;
     */
    value: GetHourlyUsageRequest;
    case: "getHourlyUsageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.HourlyUsageResponse hourly_usage_response = 509;
     */
    value: HourlyUsageResponse;
    case: "hourlyUsageResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.GetHourlyCostsRequest get_hourly_costs_request = 510;
     */
    value: GetHourlyCostsRequest;
    case: "getHourlyCostsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.HourlyCostsResponse hourly_costs_response = 511;
     */
    value: HourlyCostsResponse;
    case: "hourlyCostsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.GetCostsByGroupRequest get_costs_by_group_request = 512;
     */
    value: GetCostsByGroupRequest;
    case: "getCostsByGroupRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.CostsByGroupResponse costs_by_group_response = 513;
     */
    value: CostsByGroupResponse;
    case: "costsByGroupResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.billing.GetBillingBalanceRequest get_billing_balance_request = 514;
     */
    value: GetBillingBalanceRequest;
    case: "getBillingBalanceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.billing.BillingBalanceResponse billing_balance_response = 515;
     */
    value: BillingBalanceResponse;
    case: "billingBalanceResponse";
  } | {
    /**
     * Account usage summary — credits + storage (583-584). Redesigned /usage
     * dashboard hero cards; org resolved from conn.UserID.
     *
     * @generated from field: lvdr.v2.usage.GetUsageSummaryRequest get_usage_summary_request = 583;
     */
    value: GetUsageSummaryRequest;
    case: "getUsageSummaryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.UsageSummaryResponse usage_summary_response = 584;
     */
    value: UsageSummaryResponse;
    case: "usageSummaryResponse";
  } | {
    /**
     * Usage trend charts — credits + storage over time (585-586).
     *
     * @generated from field: lvdr.v2.usage.GetUsageHistoryRequest get_usage_history_request = 585;
     */
    value: GetUsageHistoryRequest;
    case: "getUsageHistoryRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.UsageHistoryResponse usage_history_response = 586;
     */
    value: UsageHistoryResponse;
    case: "usageHistoryResponse";
  } | {
    /**
     * Per-conversation chat credits (header pill) + per-surface credits
     * breakdown for /usage (credits-visibility spec, 590-593).
     *
     * @generated from field: lvdr.v2.budget.GetChatCreditsRequest get_chat_credits_request = 590;
     */
    value: GetChatCreditsRequest;
    case: "getChatCreditsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.GetChatCreditsResponse get_chat_credits_response = 591;
     */
    value: GetChatCreditsResponse;
    case: "getChatCreditsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.GetCreditsBreakdownRequest get_credits_breakdown_request = 592;
     */
    value: GetCreditsBreakdownRequest;
    case: "getCreditsBreakdownRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.CreditsBreakdownResponse credits_breakdown_response = 593;
     */
    value: CreditsBreakdownResponse;
    case: "creditsBreakdownResponse";
  } | {
    /**
     * Per-call voice credits (active-call bar) — ledger-sourced voice:<session>
     * spend (EL + LLM); credits-visibility spec (594-595).
     *
     * @generated from field: lvdr.v2.budget.GetVoiceCreditsRequest get_voice_credits_request = 594;
     */
    value: GetVoiceCreditsRequest;
    case: "getVoiceCreditsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.GetVoiceCreditsResponse get_voice_credits_response = 595;
     */
    value: GetVoiceCreditsResponse;
    case: "getVoiceCreditsResponse";
  } | {
    /**
     * SessionGuard — server-initiated session revocation (516)
     *
     * @generated from field: lvdr.v2.auth.SessionRevokedEvent session_revoked_event = 516;
     */
    value: SessionRevokedEvent;
    case: "sessionRevokedEvent";
  } | {
    /**
     * Research → user document library transfer (519-520, see research.proto)
     *
     * @generated from field: lvdr.v2.research.SaveResearchAsDocumentRequest save_research_as_document_request = 519;
     */
    value: SaveResearchAsDocumentRequest;
    case: "saveResearchAsDocumentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.SaveResearchAsDocumentResponse save_research_as_document_response = 520;
     */
    value: SaveResearchAsDocumentResponse;
    case: "saveResearchAsDocumentResponse";
  } | {
    /**
     * Report Diagrams (521-530) — see research.proto. Request/response pairs
     * are kept adjacent (RunDiagramEnhancementRequest/Response, etc.) per the
     * file convention; the four event types follow the responses.
     *
     * @generated from field: lvdr.v2.research.RunDiagramEnhancementRequest run_diagram_enhancement_request = 521;
     */
    value: RunDiagramEnhancementRequest;
    case: "runDiagramEnhancementRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.RunDiagramEnhancementResponse run_diagram_enhancement_response = 522;
     */
    value: RunDiagramEnhancementResponse;
    case: "runDiagramEnhancementResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchDiagramsRequest get_research_diagrams_request = 523;
     */
    value: GetResearchDiagramsRequest;
    case: "getResearchDiagramsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchDiagramsResponse research_diagrams_response = 524;
     */
    value: ResearchDiagramsResponse;
    case: "researchDiagramsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.PinDiagramToReportRequest pin_diagram_to_report_request = 525;
     */
    value: PinDiagramToReportRequest;
    case: "pinDiagramToReportRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.PinDiagramToReportResponse pin_diagram_to_report_response = 526;
     */
    value: PinDiagramToReportResponse;
    case: "pinDiagramToReportResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchDiagramAddedEvent research_diagram_added_event = 527;
     */
    value: ResearchDiagramAddedEvent;
    case: "researchDiagramAddedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchDiagramUpdatedEvent research_diagram_updated_event = 528;
     */
    value: ResearchDiagramUpdatedEvent;
    case: "researchDiagramUpdatedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchDiagramRemovedEvent research_diagram_removed_event = 529;
     */
    value: ResearchDiagramRemovedEvent;
    case: "researchDiagramRemovedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.DiagramEnhancementJobUpdateEvent diagram_enhancement_job_update_event = 530;
     */
    value: DiagramEnhancementJobUpdateEvent;
    case: "diagramEnhancementJobUpdateEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchReportRevisedEvent research_report_revised_event = 531;
     */
    value: ResearchReportRevisedEvent;
    case: "researchReportRevisedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.DeleteDiagramRequest delete_diagram_request = 532;
     */
    value: DeleteDiagramRequest;
    case: "deleteDiagramRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.DeleteDiagramResponse delete_diagram_response = 533;
     */
    value: DeleteDiagramResponse;
    case: "deleteDiagramResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UnpinDiagramRequest unpin_diagram_request = 534;
     */
    value: UnpinDiagramRequest;
    case: "unpinDiagramRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UnpinDiagramResponse unpin_diagram_response = 535;
     */
    value: UnpinDiagramResponse;
    case: "unpinDiagramResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UpdateDiagramCaptionRequest update_diagram_caption_request = 536;
     */
    value: UpdateDiagramCaptionRequest;
    case: "updateDiagramCaptionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.UpdateDiagramCaptionResponse update_diagram_caption_response = 537;
     */
    value: UpdateDiagramCaptionResponse;
    case: "updateDiagramCaptionResponse";
  } | {
    /**
     * Per-tile regenerate (560-561) — see commit 985f38265 follow-up.
     *
     * @generated from field: lvdr.v2.research.RegenerateDiagramRequest regenerate_diagram_request = 560;
     */
    value: RegenerateDiagramRequest;
    case: "regenerateDiagramRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.RegenerateDiagramResponse regenerate_diagram_response = 561;
     */
    value: RegenerateDiagramResponse;
    case: "regenerateDiagramResponse";
  } | {
    /**
     * Subscription state (538-539) — see docs/plans/2026-05-13-settings-restructure-design.md.
     *
     * @generated from field: lvdr.v2.auth.GetSubscriptionStateRequest get_subscription_state_request = 538;
     */
    value: GetSubscriptionStateRequest;
    case: "getSubscriptionStateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.auth.GetSubscriptionStateResponse subscription_state_response = 539;
     */
    value: GetSubscriptionStateResponse;
    case: "subscriptionStateResponse";
  } | {
    /**
     * Report library — cost estimate + HITL approval (540-542) — see
     * docs/plans/2026-05-13-report-library-and-research-passes-design.md.
     * The matching GenerateReportRequest/Response live at field 343/344
     * (repurposed in place from the unused GenerateOutputFormRequest pair).
     *
     * @generated from field: lvdr.v2.research.EstimateReportRunRequest estimate_report_run_request = 540;
     */
    value: EstimateReportRunRequest;
    case: "estimateReportRunRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.EstimateReportRunResponse estimate_report_run_response = 541;
     */
    value: EstimateReportRunResponse;
    case: "estimateReportRunResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.hitl.ReportRunCostApproval report_run_cost_approval = 542;
     */
    value: ReportRunCostApproval;
    case: "reportRunCostApproval";
  } | {
    /**
     * Report library — research output-form catalog (556-557). Surfaces the
     * strategy's primary `output` choices + `available_post_forms` to the
     * Generate-report dialog so it shows the same options the user saw at
     * research setup. Field numbers chosen after the Recordings 543-555 range
     * so the existing wire layout is undisturbed.
     *
     * @generated from field: lvdr.v2.research.ListResearchOutputFormsRequest list_research_output_forms_request = 556;
     */
    value: ListResearchOutputFormsRequest;
    case: "listResearchOutputFormsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ListResearchOutputFormsResponse list_research_output_forms_response = 557;
     */
    value: ListResearchOutputFormsResponse;
    case: "listResearchOutputFormsResponse";
  } | {
    /**
     * Recordings & ASR (543-555) — see docs/plans/2026-05-12-recordings-asr-design.md.
     *
     * @generated from field: lvdr.v2.recordings.ListRecordingsRequest list_recordings_request = 543;
     */
    value: ListRecordingsRequest;
    case: "listRecordingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.ListRecordingsResponse list_recordings_response = 544;
     */
    value: ListRecordingsResponse;
    case: "listRecordingsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.GetRecordingRequest get_recording_request = 545;
     */
    value: GetRecordingRequest;
    case: "getRecordingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.GetRecordingResponse get_recording_response = 546;
     */
    value: GetRecordingResponse;
    case: "getRecordingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.UpdateRecordingRequest update_recording_request = 547;
     */
    value: UpdateRecordingRequest;
    case: "updateRecordingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.UpdateRecordingResponse update_recording_response = 548;
     */
    value: UpdateRecordingResponse;
    case: "updateRecordingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.DeleteRecordingRequest delete_recording_request = 549;
     */
    value: DeleteRecordingRequest;
    case: "deleteRecordingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.DeleteRecordingResponse delete_recording_response = 550;
     */
    value: DeleteRecordingResponse;
    case: "deleteRecordingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.RetryTranscriptionRequest retry_transcription_request = 551;
     */
    value: RetryTranscriptionRequest;
    case: "retryTranscriptionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.RetryTranscriptionResponse retry_transcription_response = 552;
     */
    value: RetryTranscriptionResponse;
    case: "retryTranscriptionResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.PromoteRecordingRequest promote_recording_request = 553;
     */
    value: PromoteRecordingRequest;
    case: "promoteRecordingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.PromoteRecordingResponse promote_recording_response = 554;
     */
    value: PromoteRecordingResponse;
    case: "promoteRecordingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.RecordingStatusEvent recording_status_event = 555;
     */
    value: RecordingStatusEvent;
    case: "recordingStatusEvent";
  } | {
    /**
     * HITL criteria override (558-559) — mid-execution recovery from
     * extract_criteria MinItems failures. See dag.proto::SubmitHITLCriteriaRequest.
     *
     * @generated from field: lvdr.v2.dag.SubmitHITLCriteriaRequest submit_hitl_criteria_request = 558;
     */
    value: SubmitHITLCriteriaRequest;
    case: "submitHitlCriteriaRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.SubmitHITLCriteriaResponse submit_hitl_criteria_response = 559;
     */
    value: SubmitHITLCriteriaResponse;
    case: "submitHitlCriteriaResponse";
  } | {
    /**
     * Docling Premium converter choice + free-retry (562-565) — see
     * docs/plans/2026-05-18-docling-premium.md Wave 7. The setConverterChoice
     * handler updates UserDocument.ConverterChoice and re-triggers indexing;
     * retryDocling consumes a `docling:retry_token:<docID>` written by the
     * orchestrator's fallback path and re-runs conversion at no preflight
     * cost (debits still apply on success).
     *
     * @generated from field: lvdr.v2.document.SetConverterChoiceRequest set_converter_choice_request = 562;
     */
    value: SetConverterChoiceRequest;
    case: "setConverterChoiceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.SetConverterChoiceResponse set_converter_choice_response = 563;
     */
    value: SetConverterChoiceResponse;
    case: "setConverterChoiceResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.RetryDoclingRequest retry_docling_request = 564;
     */
    value: RetryDoclingRequest;
    case: "retryDoclingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.RetryDoclingResponse retry_docling_response = 565;
     */
    value: RetryDoclingResponse;
    case: "retryDoclingResponse";
  } | {
    /**
     * Multi-backend user migration — Phase 4 WS redirect (566). Sent by a
     * backend that doesn't own the user's lease; FE caches the target and
     * reconnects there. Distinct from SessionRedirect at 250 (Traefik-cookie
     * route): SessionMovedFrame carries an explicit `?b=<id>` query target
     * pinned to the lease owner. See
     * docs/plans/2026-05-18-multibackend-user-migration-design.md §4.
     *
     * @generated from field: lvdr.v2.cluster.SessionMovedFrame session_moved_frame = 566;
     */
    value: SessionMovedFrame;
    case: "sessionMovedFrame";
  } | {
    /**
     * Grounded turn engine (567-569) — see
     * docs/plans/2026-05-21-grounded-turn-engine-design.md ("API / proto /
     * wire"). uiActionEvent is a typed UI directive pushed via
     * BroadcastEnvelopeToUser; chatGroundingReport carries per-turn evidence +
     * deterministic confidence; chatRetrievalEvent carries live
     * searching/found activity.
     *
     * @generated from field: lvdr.v2.chat.UIActionEvent ui_action_event = 567;
     */
    value: UIActionEvent;
    case: "uiActionEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.GroundingReport chat_grounding_report = 568;
     */
    value: GroundingReport;
    case: "chatGroundingReport";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ChatRetrievalEvent chat_retrieval_event = 569;
     */
    value: ChatRetrievalEvent;
    case: "chatRetrievalEvent";
  } | {
    /**
     * R7 — consistent error handling (570). The typed error payload, carried for
     * WS replies alongside (and eventually replacing) the legacy `error`
     * ErrorResponse field above. 567-569 are the grounded-turn-engine block;
     * 571/572 remain reserved for R13a/R25. Built only by the backend mapper
     * (domain.MapError → error_envelope.go).
     *
     * @generated from field: lvdr.v2.errors.ErrorEvent error_event = 570;
     */
    value: ErrorEvent;
    case: "errorEvent";
  } | {
    /**
     * R14 — personas + onboarding (573-580). Config-driven persona catalog,
     * apply-persona (installs skill pack + writes per-user defaults), and the
     * new-user onboarding wizard state. 571/572 stay reserved for R13a/R25.
     *
     * @generated from field: lvdr.v2.persona.ListPersonasRequest list_personas_request = 573;
     */
    value: ListPersonasRequest;
    case: "listPersonasRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.ListPersonasResponse list_personas_response = 574;
     */
    value: ListPersonasResponse;
    case: "listPersonasResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.ApplyPersonaRequest apply_persona_request = 575;
     */
    value: ApplyPersonaRequest;
    case: "applyPersonaRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.ApplyPersonaResponse apply_persona_response = 576;
     */
    value: ApplyPersonaResponse;
    case: "applyPersonaResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.GetOnboardingStateRequest get_onboarding_state_request = 577;
     */
    value: GetOnboardingStateRequest;
    case: "getOnboardingStateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.GetOnboardingStateResponse get_onboarding_state_response = 578;
     */
    value: GetOnboardingStateResponse;
    case: "getOnboardingStateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.CompleteOnboardingRequest complete_onboarding_request = 579;
     */
    value: CompleteOnboardingRequest;
    case: "completeOnboardingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.persona.CompleteOnboardingResponse complete_onboarding_response = 580;
     */
    value: CompleteOnboardingResponse;
    case: "completeOnboardingResponse";
  } | {
    /**
     * Knowledge node usage / reverse provenance (581-582) — R15 influence
     * transparency. Gated behind LVDR_KNOWLEDGE_USAGE_TRACKING_ENABLED.
     *
     * @generated from field: lvdr.v2.knowledge.GetNodeUsageRequest get_node_usage_request = 581;
     */
    value: GetNodeUsageRequest;
    case: "getNodeUsageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.knowledge.GetNodeUsageResponse get_node_usage_response = 582;
     */
    value: GetNodeUsageResponse;
    case: "getNodeUsageResponse";
  } | {
    /**
     * Feature-flag catalog live push (587) — server-initiated sentinel that
     * tells connected clients the catalog snapshot changed (admin flip or
     * runtime override reset). Body is empty; clients refetch
     * /api/v1/features on receipt to pick up the new state. Keeps catalog
     * metadata out of the proto so wire and source-of-truth never drift.
     *
     * @generated from field: lvdr.v2.admin.FeaturesUpdatedEvent features_updated_event = 587;
     */
    value: FeaturesUpdatedEvent;
    case: "featuresUpdatedEvent";
  } | {
    /**
     * Auto-refill settings (per-org config; credit auto-refill feature, 596-598).
     * Requests carry no org_id — the server resolves the org from the session.
     *
     * @generated from field: lvdr.v2.budget.GetAutoRefillSettingsRequest get_auto_refill_settings_request = 596;
     */
    value: GetAutoRefillSettingsRequest;
    case: "getAutoRefillSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.UpdateAutoRefillSettingsRequest update_auto_refill_settings_request = 597;
     */
    value: UpdateAutoRefillSettingsRequest;
    case: "updateAutoRefillSettingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.budget.AutoRefillSettingsResponse auto_refill_settings_response = 598;
     */
    value: AutoRefillSettingsResponse;
    case: "autoRefillSettingsResponse";
  } | {
    /**
     * Extensible workflow triggers v2 — catalog + manual contextual actions
     * (599-604). The catalog drives the FE palette/property panel from the
     * backend descriptor registry; manual-actions/fire back the contextual
     * buttons. Handlers are Phase 3; only the proto messages land here.
     *
     * @generated from field: lvdr.v2.workflow.TriggerCatalogRequest trigger_catalog_request = 599;
     */
    value: TriggerCatalogRequest;
    case: "triggerCatalogRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.TriggerCatalogResponse trigger_catalog_response = 600;
     */
    value: TriggerCatalogResponse;
    case: "triggerCatalogResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ManualActionsRequest manual_actions_request = 601;
     */
    value: ManualActionsRequest;
    case: "manualActionsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ManualActionsResponse manual_actions_response = 602;
     */
    value: ManualActionsResponse;
    case: "manualActionsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.FireManualTriggerRequest fire_manual_trigger_request = 603;
     */
    value: FireManualTriggerRequest;
    case: "fireManualTriggerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.FireManualTriggerResponse fire_manual_trigger_response = 604;
     */
    value: FireManualTriggerResponse;
    case: "fireManualTriggerResponse";
  } | {
    /**
     * Private home mantra (607-609) — per-user encrypted Badger, not PG.
     *
     * @generated from field: lvdr.v2.mantra.GetMantraRequest get_mantra_request = 607;
     */
    value: GetMantraRequest;
    case: "getMantraRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.mantra.UpdateMantraRequest update_mantra_request = 608;
     */
    value: UpdateMantraRequest;
    case: "updateMantraRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.mantra.MantraResponse mantra_response = 609;
     */
    value: MantraResponse;
    case: "mantraResponse";
  } | {
    /**
     * Workflow Designer (610-613) — agentic build & maintenance. The turn
     * streams DesignerTurnStreamEvent chunks; drift alerts push unsolicited.
     *
     * @generated from field: lvdr.v2.workflow.RunDesignerTurnRequest run_designer_turn_request = 610;
     */
    value: RunDesignerTurnRequest;
    case: "runDesignerTurnRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.RunDesignerTurnResponse run_designer_turn_response = 611;
     */
    value: RunDesignerTurnResponse;
    case: "runDesignerTurnResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.DesignerTurnStreamEvent designer_turn_stream_event = 612;
     */
    value: DesignerTurnStreamEvent;
    case: "designerTurnStreamEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.CapabilityDriftAlert capability_drift_alert = 613;
     */
    value: CapabilityDriftAlert;
    case: "capabilityDriftAlert";
  } | {
    /**
     * Chat thinking-levels depth UI (Phase 1c) — "think harder" re-run request.
     * (Renumbered 610→614 on the master integration: the workflow-designer merge
     * independently took 610-613.)
     *
     * @generated from field: lvdr.v2.chat.ThinkHarderRequest think_harder_request = 614;
     */
    value: ThinkHarderRequest;
    case: "thinkHarderRequest";
  } | {
    /**
     * Workspace mount/unmount (E1 Phase 3): cache the client-unwrapped WS-DEK in
     * the session keyring + lazily open the encrypted island; unmount zeroes it.
     *
     * @generated from field: lvdr.v2.workspace.MountWorkspaceRequest mount_workspace_request = 615;
     */
    value: MountWorkspaceRequest;
    case: "mountWorkspaceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.MountWorkspaceResponse mount_workspace_response = 616;
     */
    value: MountWorkspaceResponse;
    case: "mountWorkspaceResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.UnmountWorkspaceRequest unmount_workspace_request = 617;
     */
    value: UnmountWorkspaceRequest;
    case: "unmountWorkspaceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.UnmountWorkspaceResponse unmount_workspace_response = 618;
     */
    value: UnmountWorkspaceResponse;
    case: "unmountWorkspaceResponse";
  } | {
    /**
     * Workspace revocation re-key (E1 Phase 4): rotate the WS-DEK so a removed
     * member's previously-held key is dead.
     *
     * @generated from field: lvdr.v2.workspace.RekeyWorkspaceRequest rekey_workspace_request = 619;
     */
    value: RekeyWorkspaceRequest;
    case: "rekeyWorkspaceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.RekeyWorkspaceResponse rekey_workspace_response = 620;
     */
    value: RekeyWorkspaceResponse;
    case: "rekeyWorkspaceResponse";
  } | {
    /**
     * Workspace active-context switch (E1 Phase 8): select which mounted workspace
     * billable actions are attributed to for this session.
     *
     * @generated from field: lvdr.v2.workspace.SetActiveWorkspaceRequest set_active_workspace_request = 621;
     */
    value: SetActiveWorkspaceRequest;
    case: "setActiveWorkspaceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.SetActiveWorkspaceResponse set_active_workspace_response = 622;
     */
    value: SetActiveWorkspaceResponse;
    case: "setActiveWorkspaceResponse";
  } | {
    /**
     * Transfer content between areas (E1 Phase 7): copy/move a document, note, or
     * research run between a personal area and a shared Workspace (or ws↔ws), with
     * a consent gate on exposure into a shared workspace. The transfer runs async
     * (detached goroutine) so a large copy never blocks the connection — the
     * completed-event reports the outcome.
     *
     * @generated from field: lvdr.v2.workspace.TransferContentRequest transfer_content_request = 623;
     */
    value: TransferContentRequest;
    case: "transferContentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.TransferContentResponse transfer_content_response = 624;
     */
    value: TransferContentResponse;
    case: "transferContentResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.TransferContentCompletedEvent transfer_content_completed_event = 625;
     */
    value: TransferContentCompletedEvent;
    case: "transferContentCompletedEvent";
  } | {
    /**
     * Workspace notification push (E1 Phase 11): server→client when a persistent
     * notification is created for an online recipient. CRUD is over HTTP.
     *
     * @generated from field: lvdr.v2.workspace.WorkspaceNotificationEvent workspace_notification_event = 626;
     */
    value: WorkspaceNotificationEvent;
    case: "workspaceNotificationEvent";
  } | {
    /**
     * E1 Phase 10: editable workspace notes (CRUD), real-time sync change events,
     * and advisory edit-locks/presence. Requests 627-635, server pushes 636-637.
     *
     * @generated from field: lvdr.v2.workspace.CreateWorkspaceNoteRequest create_workspace_note_request = 627;
     */
    value: CreateWorkspaceNoteRequest;
    case: "createWorkspaceNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.GetWorkspaceNoteRequest get_workspace_note_request = 628;
     */
    value: GetWorkspaceNoteRequest;
    case: "getWorkspaceNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ListWorkspaceNotesRequest list_workspace_notes_request = 629;
     */
    value: ListWorkspaceNotesRequest;
    case: "listWorkspaceNotesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ListWorkspaceNotesResponse list_workspace_notes_response = 630;
     */
    value: ListWorkspaceNotesResponse;
    case: "listWorkspaceNotesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.UpdateWorkspaceNoteRequest update_workspace_note_request = 631;
     */
    value: UpdateWorkspaceNoteRequest;
    case: "updateWorkspaceNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.DeleteWorkspaceNoteRequest delete_workspace_note_request = 632;
     */
    value: DeleteWorkspaceNoteRequest;
    case: "deleteWorkspaceNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.WorkspaceNoteResponse workspace_note_response = 633;
     */
    value: WorkspaceNoteResponse;
    case: "workspaceNoteResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.DeleteWorkspaceNoteResponse delete_workspace_note_response = 634;
     */
    value: DeleteWorkspaceNoteResponse;
    case: "deleteWorkspaceNoteResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.AcquireEditLockRequest acquire_edit_lock_request = 635;
     */
    value: AcquireEditLockRequest;
    case: "acquireEditLockRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.AcquireEditLockResponse acquire_edit_lock_response = 636;
     */
    value: AcquireEditLockResponse;
    case: "acquireEditLockResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ReleaseEditLockRequest release_edit_lock_request = 637;
     */
    value: ReleaseEditLockRequest;
    case: "releaseEditLockRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ReleaseEditLockResponse release_edit_lock_response = 638;
     */
    value: ReleaseEditLockResponse;
    case: "releaseEditLockResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.WorkspaceChangeEvent workspace_change_event = 639;
     */
    value: WorkspaceChangeEvent;
    case: "workspaceChangeEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.PresenceEvent workspace_presence_event = 640;
     */
    value: PresenceEvent;
    case: "workspacePresenceEvent";
  } | {
    /**
     * E1 Phase 12 — immutable document snapshots (641-648)
     *
     * @generated from field: lvdr.v2.workspace.CreateSnapshotRequest create_snapshot_request = 641;
     */
    value: CreateSnapshotRequest;
    case: "createSnapshotRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.GetSnapshotRequest get_snapshot_request = 642;
     */
    value: GetSnapshotRequest;
    case: "getSnapshotRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.SnapshotContentResponse snapshot_content_response = 643;
     */
    value: SnapshotContentResponse;
    case: "snapshotContentResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ListSnapshotsRequest list_snapshots_request = 644;
     */
    value: ListSnapshotsRequest;
    case: "listSnapshotsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ListSnapshotsResponse list_snapshots_response = 645;
     */
    value: ListSnapshotsResponse;
    case: "listSnapshotsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.AddSnapshotTagRequest add_snapshot_tag_request = 646;
     */
    value: AddSnapshotTagRequest;
    case: "addSnapshotTagRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.SetSnapshotLegalHoldRequest set_snapshot_legal_hold_request = 647;
     */
    value: SetSnapshotLegalHoldRequest;
    case: "setSnapshotLegalHoldRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.SnapshotResponse snapshot_response = 648;
     */
    value: SnapshotResponse;
    case: "snapshotResponse";
  } | {
    /**
     * Note version-history snapshots (NOTES-05)
     *
     * @generated from field: lvdr.v2.note.CreateNoteSnapshotRequest create_note_snapshot_request = 649;
     */
    value: CreateNoteSnapshotRequest;
    case: "createNoteSnapshotRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.ListNoteSnapshotsRequest list_note_snapshots_request = 650;
     */
    value: ListNoteSnapshotsRequest;
    case: "listNoteSnapshotsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteSnapshotListResponse note_snapshot_list_response = 651;
     */
    value: NoteSnapshotListResponse;
    case: "noteSnapshotListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.note.GetNoteSnapshotRequest get_note_snapshot_request = 652;
     */
    value: GetNoteSnapshotRequest;
    case: "getNoteSnapshotRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.note.NoteSnapshotContentResponse note_snapshot_content_response = 653;
     */
    value: NoteSnapshotContentResponse;
    case: "noteSnapshotContentResponse";
  } | {
    /**
     * Workspace export (GDPR legal-hold release path) — owner-session ZIP export
     * of a mounted workspace island (ws-erasure-export, 2026-06-10).
     *
     * @generated from field: lvdr.v2.workspace.ExportWorkspaceRequest export_workspace_request = 654;
     */
    value: ExportWorkspaceRequest;
    case: "exportWorkspaceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ExportWorkspaceResponse export_workspace_response = 655;
     */
    value: ExportWorkspaceResponse;
    case: "exportWorkspaceResponse";
  } | {
    /**
     * Workspace note version-history snapshots (NOTES-05 parity)
     *
     * @generated from field: lvdr.v2.workspace.CreateWorkspaceNoteSnapshotRequest create_workspace_note_snapshot_request = 656;
     */
    value: CreateWorkspaceNoteSnapshotRequest;
    case: "createWorkspaceNoteSnapshotRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.ListWorkspaceNoteSnapshotsRequest list_workspace_note_snapshots_request = 657;
     */
    value: ListWorkspaceNoteSnapshotsRequest;
    case: "listWorkspaceNoteSnapshotsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workspace.GetWorkspaceNoteSnapshotRequest get_workspace_note_snapshot_request = 658;
     */
    value: GetWorkspaceNoteSnapshotRequest;
    case: "getWorkspaceNoteSnapshotRequest";
  } | {
    /**
     * Research Progress View v2 — diagram + live insights projection (659-661).
     * Outbound only: snapshot on (re)subscribe + GET /api/v1/research/:id/progress-view,
     * plus findings/digest deltas. See docs/plans/2026-06-13-research-progress-view-plan.md.
     *
     * @generated from field: lvdr.v2.research.ResearchProgressView research_progress_view = 659;
     */
    value: ResearchProgressView;
    case: "researchProgressView";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchFindingsEvent research_findings_event = 660;
     */
    value: ResearchFindingsEvent;
    case: "researchFindingsEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.ResearchInsightDigestEvent research_insight_digest_event = 661;
     */
    value: ResearchInsightDigestEvent;
    case: "researchInsightDigestEvent";
  } | {
    /**
     * Agentic chat tool-use loop (Spec 1, 662-664). Gated behind
     * LVDR_CHAT_AGENT_LOOP (default off). agentStepEvent streams the working
     * trace; agentAuditEvent delivers the per-turn "actions taken" list;
     * resumeAgentRequest authorizes a paused write (confirm/skip/undo). See
     * docs/plans/2026-06-21-agentic-chat-loop-design.md.
     *
     * @generated from field: lvdr.v2.chat.AgentStepEvent agent_step_event = 662;
     */
    value: AgentStepEvent;
    case: "agentStepEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.AgentAuditEvent agent_audit_event = 663;
     */
    value: AgentAuditEvent;
    case: "agentAuditEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ResumeAgentRequest resume_agent_request = 664;
     */
    value: ResumeAgentRequest;
    case: "resumeAgentRequest";
  } | {
    /**
     * Research-defaults settings catalog — selectable strategies + their static
     * intent-questions, voice catalog, profile catalog (665-666). Read-only;
     * drives the Settings → Research defaults editor.
     *
     * @generated from field: lvdr.v2.research.GetResearchDefaultsCatalogRequest get_research_defaults_catalog_request = 665;
     */
    value: GetResearchDefaultsCatalogRequest;
    case: "getResearchDefaultsCatalogRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.GetResearchDefaultsCatalogResponse get_research_defaults_catalog_response = 666;
     */
    value: GetResearchDefaultsCatalogResponse;
    case: "getResearchDefaultsCatalogResponse";
  } | {
    /**
     * Per-user MCP servers (Spec 3, LVDR_CHAT_MCP_USER). A user manages their own
     * remote MCP servers; tools appear in their agentic-loop catalog only. 667-676.
     *
     * @generated from field: lvdr.v2.chat.ListUserMcpServersRequest list_user_mcp_servers_request = 667;
     */
    value: ListUserMcpServersRequest;
    case: "listUserMcpServersRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.ListUserMcpServersResponse list_user_mcp_servers_response = 668;
     */
    value: ListUserMcpServersResponse;
    case: "listUserMcpServersResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.AddUserMcpServerRequest add_user_mcp_server_request = 669;
     */
    value: AddUserMcpServerRequest;
    case: "addUserMcpServerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.AddUserMcpServerResponse add_user_mcp_server_response = 670;
     */
    value: AddUserMcpServerResponse;
    case: "addUserMcpServerResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.UpdateUserMcpServerRequest update_user_mcp_server_request = 671;
     */
    value: UpdateUserMcpServerRequest;
    case: "updateUserMcpServerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.UpdateUserMcpServerResponse update_user_mcp_server_response = 672;
     */
    value: UpdateUserMcpServerResponse;
    case: "updateUserMcpServerResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.RemoveUserMcpServerRequest remove_user_mcp_server_request = 673;
     */
    value: RemoveUserMcpServerRequest;
    case: "removeUserMcpServerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.RemoveUserMcpServerResponse remove_user_mcp_server_response = 674;
     */
    value: RemoveUserMcpServerResponse;
    case: "removeUserMcpServerResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.TestUserMcpServerRequest test_user_mcp_server_request = 675;
     */
    value: TestUserMcpServerRequest;
    case: "testUserMcpServerRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.TestUserMcpServerResponse test_user_mcp_server_response = 676;
     */
    value: TestUserMcpServerResponse;
    case: "testUserMcpServerResponse";
  } | {
    /**
     * Audio Overview — multi-speaker podcast generation (AUDIO-01). 677-684.
     *
     * @generated from field: lvdr.v2.audio.ListAudioOverviewsRequest list_audio_overviews_request = 677;
     */
    value: ListAudioOverviewsRequest;
    case: "listAudioOverviewsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.audio.ListAudioOverviewsResponse list_audio_overviews_response = 678;
     */
    value: ListAudioOverviewsResponse;
    case: "listAudioOverviewsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.audio.GetAudioOverviewRequest get_audio_overview_request = 679;
     */
    value: GetAudioOverviewRequest;
    case: "getAudioOverviewRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.audio.GetAudioOverviewResponse get_audio_overview_response = 680;
     */
    value: GetAudioOverviewResponse;
    case: "getAudioOverviewResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.audio.DeleteAudioOverviewRequest delete_audio_overview_request = 681;
     */
    value: DeleteAudioOverviewRequest;
    case: "deleteAudioOverviewRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.audio.DeleteAudioOverviewResponse delete_audio_overview_response = 682;
     */
    value: DeleteAudioOverviewResponse;
    case: "deleteAudioOverviewResponse";
  } | {
    /**
     * 684 reserved for audio-overview expansion.
     *
     * @generated from field: lvdr.v2.audio.AudioEpisodeEvent audio_episode_event = 683;
     */
    value: AudioEpisodeEvent;
    case: "audioEpisodeEvent";
  } | {
    /**
     * Research title regenerate-as-preview (685-686). Returns a fresh LLM title
     * candidate WITHOUT persisting; the client commits via UpdateResearchRequest.
     *
     * @generated from field: lvdr.v2.research.RegenerateResearchTitleRequest regenerate_research_title_request = 685;
     */
    value: RegenerateResearchTitleRequest;
    case: "regenerateResearchTitleRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.RegenerateResearchTitleResponse regenerate_research_title_response = 686;
     */
    value: RegenerateResearchTitleResponse;
    case: "regenerateResearchTitleResponse";
  } | {
    /**
     * Per-category storage breakdown for /usage (storage-accounting spec, 687-688).
     *
     * @generated from field: lvdr.v2.usage.GetStorageBreakdownRequest get_storage_breakdown_request = 687;
     */
    value: GetStorageBreakdownRequest;
    case: "getStorageBreakdownRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.usage.StorageBreakdownResponse storage_breakdown_response = 688;
     */
    value: StorageBreakdownResponse;
    case: "storageBreakdownResponse";
  } | {
    /**
     * FE-36: lazy DAG node input/output content fetch for the inspection panel (689-690).
     *
     * @generated from field: lvdr.v2.dag.GetDAGNodeContentRequest get_dag_node_content_request = 689;
     */
    value: GetDAGNodeContentRequest;
    case: "getDagNodeContentRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GetDAGNodeContentResponse get_dag_node_content_response = 690;
     */
    value: GetDAGNodeContentResponse;
    case: "getDagNodeContentResponse";
  } | {
    /**
     * COS Phase 0: per-user task store CRUD (691-698).
     *
     * @generated from field: lvdr.v2.tasks.CreateTaskRequest create_task_request = 691;
     */
    value: CreateTaskRequest;
    case: "createTaskRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.GetTaskRequest get_task_request = 692;
     */
    value: GetTaskRequest;
    case: "getTaskRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.UpdateTaskRequest update_task_request = 693;
     */
    value: UpdateTaskRequest;
    case: "updateTaskRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.DeleteTaskRequest delete_task_request = 694;
     */
    value: DeleteTaskRequest;
    case: "deleteTaskRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.ListTasksRequest list_tasks_request = 695;
     */
    value: ListTasksRequest;
    case: "listTasksRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.TaskResponse task_response = 696;
     */
    value: TaskResponse;
    case: "taskResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.TaskListResponse task_list_response = 697;
     */
    value: TaskListResponse;
    case: "taskListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.DeleteTaskResponse delete_task_response = 698;
     */
    value: DeleteTaskResponse;
    case: "deleteTaskResponse";
  } | {
    /**
     * COS Phase 0b: task tags + cross-item links — dedicated single-item ops
     * (each replies with task_response = 696). (699-702).
     *
     * @generated from field: lvdr.v2.tasks.AddTaskTagRequest add_task_tag_request = 699;
     */
    value: AddTaskTagRequest;
    case: "addTaskTagRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.RemoveTaskTagRequest remove_task_tag_request = 700;
     */
    value: RemoveTaskTagRequest;
    case: "removeTaskTagRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.LinkTaskRequest link_task_request = 701;
     */
    value: LinkTaskRequest;
    case: "linkTaskRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.UnlinkTaskRequest unlink_task_request = 702;
     */
    value: UnlinkTaskRequest;
    case: "unlinkTaskRequest";
  } | {
    /**
     * TASKS-05 recurring task series (740-748). Non-contiguous with the 691-702
     * task block above because 703-738 were taken first — field numbers are wire
     * identity and can never be renumbered to tidy the grouping.
     *
     * @generated from field: lvdr.v2.tasks.CreateSeriesRequest create_series_request = 740;
     */
    value: CreateSeriesRequest;
    case: "createSeriesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.UpdateSeriesRequest update_series_request = 741;
     */
    value: UpdateSeriesRequest;
    case: "updateSeriesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.ListSeriesRequest list_series_request = 742;
     */
    value: ListSeriesRequest;
    case: "listSeriesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.SkipOccurrenceRequest skip_occurrence_request = 743;
     */
    value: SkipOccurrenceRequest;
    case: "skipOccurrenceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.PauseSeriesRequest pause_series_request = 744;
     */
    value: PauseSeriesRequest;
    case: "pauseSeriesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.DeleteSeriesRequest delete_series_request = 745;
     */
    value: DeleteSeriesRequest;
    case: "deleteSeriesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.SeriesResponse series_response = 746;
     */
    value: SeriesResponse;
    case: "seriesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.SeriesListResponse series_list_response = 747;
     */
    value: SeriesListResponse;
    case: "seriesListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.DeleteSeriesResponse delete_series_response = 748;
     */
    value: DeleteSeriesResponse;
    case: "deleteSeriesResponse";
  } | {
    /**
     * Report-run per-version progress + cancel (703-705).
     *
     * @generated from field: lvdr.v2.research.ReportRunProgressEvent report_run_progress_event = 703;
     */
    value: ReportRunProgressEvent;
    case: "reportRunProgressEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.research.CancelReportRunRequest cancel_report_run_request = 704;
     */
    value: CancelReportRunRequest;
    case: "cancelReportRunRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.research.CancelReportRunResponse cancel_report_run_response = 705;
     */
    value: CancelReportRunResponse;
    case: "cancelReportRunResponse";
  } | {
    /**
     * AIOS-01 Personal Context Layer — user-authored standing preferences,
     * injected as an instruction overlay (never groundable/citable).
     *
     * @generated from field: lvdr.v2.personalcontext.GetPersonalContextRequest get_personal_context_request = 706;
     */
    value: GetPersonalContextRequest;
    case: "getPersonalContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.personalcontext.UpdatePersonalContextRequest update_personal_context_request = 707;
     */
    value: UpdatePersonalContextRequest;
    case: "updatePersonalContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.personalcontext.PersonalContextResponse personal_context_response = 708;
     */
    value: PersonalContextResponse;
    case: "personalContextResponse";
  } | {
    /**
     * COS-12 Background Execution Authorization — no-escrow offline workflow
     * execution. Client seals the DEK under a device-held token; the server
     * stores only the sealed blob + token hash. Consent IS the sealed blob.
     *
     * @generated from field: lvdr.v2.bgauth.AuthorizeBackgroundRequest authorize_background_request = 709;
     */
    value: AuthorizeBackgroundRequest;
    case: "authorizeBackgroundRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.RevokeBackgroundRequest revoke_background_request = 710;
     */
    value: RevokeBackgroundRequest;
    case: "revokeBackgroundRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.SetBackgroundAccountRequest set_background_account_request = 711;
     */
    value: SetBackgroundAccountRequest;
    case: "setBackgroundAccountRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.ListBackgroundAuthRequest list_background_auth_request = 712;
     */
    value: ListBackgroundAuthRequest;
    case: "listBackgroundAuthRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.BackgroundAuthResponse background_auth_response = 713;
     */
    value: BackgroundAuthResponse;
    case: "backgroundAuthResponse";
  } | {
    /**
     * COS-05 send grants — list/revoke the one-run grants and standing per-step
     * releases that let a scheduled send proceed without waking the user.
     *
     * @generated from field: lvdr.v2.workflow.ListSendGrantsRequest list_send_grants_request = 736;
     */
    value: ListSendGrantsRequest;
    case: "listSendGrantsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.RevokeSendGrantRequest revoke_send_grant_request = 737;
     */
    value: RevokeSendGrantRequest;
    case: "revokeSendGrantRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.SendGrantsResponse send_grants_response = 738;
     */
    value: SendGrantsResponse;
    case: "sendGrantsResponse";
  } | {
    /**
     * WFEV-04 research tags
     *
     * @generated from field: lvdr.v2.research.SetResearchTagsRequest set_research_tags_request = 739;
     */
    value: SetResearchTagsRequest;
    case: "setResearchTagsRequest";
  } | {
    /**
     * DECK-3 in-product deck editor — one edit-op vocabulary drives WYSIWYG +
     * chat-edit; per-user Badger persistence. Flag LVDR_DECK_ENABLED (default off).
     *
     * @generated from field: lvdr.v2.deck.DeckListRequest deck_list_request = 714;
     */
    value: DeckListRequest;
    case: "deckListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckListResponse deck_list_response = 715;
     */
    value: DeckListResponse;
    case: "deckListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckGetRequest deck_get_request = 716;
     */
    value: DeckGetRequest;
    case: "deckGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckGetResponse deck_get_response = 717;
     */
    value: DeckGetResponse;
    case: "deckGetResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckCreateRequest deck_create_request = 718;
     */
    value: DeckCreateRequest;
    case: "deckCreateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckCreateResponse deck_create_response = 719;
     */
    value: DeckCreateResponse;
    case: "deckCreateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckApplyOpsRequest deck_apply_ops_request = 720;
     */
    value: DeckApplyOpsRequest;
    case: "deckApplyOpsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckApplyOpsResponse deck_apply_ops_response = 721;
     */
    value: DeckApplyOpsResponse;
    case: "deckApplyOpsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckChatEditRequest deck_chat_edit_request = 722;
     */
    value: DeckChatEditRequest;
    case: "deckChatEditRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckChatEditResponse deck_chat_edit_response = 723;
     */
    value: DeckChatEditResponse;
    case: "deckChatEditResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckRenderDiagramRequest deck_render_diagram_request = 724;
     */
    value: DeckRenderDiagramRequest;
    case: "deckRenderDiagramRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckRenderDiagramResponse deck_render_diagram_response = 725;
     */
    value: DeckRenderDiagramResponse;
    case: "deckRenderDiagramResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckExportPptxRequest deck_export_pptx_request = 726;
     */
    value: DeckExportPptxRequest;
    case: "deckExportPptxRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckExportPptxResponse deck_export_pptx_response = 727;
     */
    value: DeckExportPptxResponse;
    case: "deckExportPptxResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckGenerateImageRequest deck_generate_image_request = 728;
     */
    value: DeckGenerateImageRequest;
    case: "deckGenerateImageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckGenerateImageResponse deck_generate_image_response = 729;
     */
    value: DeckGenerateImageResponse;
    case: "deckGenerateImageResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.RaiseCreditCeilingRequest raise_credit_ceiling_request = 730;
     */
    value: RaiseCreditCeilingRequest;
    case: "raiseCreditCeilingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.execution.RaiseCreditCeilingResponse raise_credit_ceiling_response = 731;
     */
    value: RaiseCreditCeilingResponse;
    case: "raiseCreditCeilingResponse";
  } | {
    /**
     * Deck PDF export. Non-contiguous with the 712-729 deck block above because
     * 730/731 were taken by raise_credit_ceiling first — field numbers are wire
     * identity and can never be renumbered to tidy the grouping.
     *
     * @generated from field: lvdr.v2.deck.DeckExportPdfRequest deck_export_pdf_request = 732;
     */
    value: DeckExportPdfRequest;
    case: "deckExportPdfRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckExportPdfResponse deck_export_pdf_response = 733;
     */
    value: DeckExportPdfResponse;
    case: "deckExportPdfResponse";
  } | {
    /**
     * RT-01 realtime fan-out. Both are pushed UNSOLICITED by a realtime.Hub —
     * they are never replies, which is exactly why they are their own messages
     * rather than a re-use of the corresponding *Response. The deck and
     * knowledge frontends correlate replies by requestId / a pending-id set, so
     * an unsolicited *Response would be mis-routed or dropped.
     *
     * @generated from field: lvdr.v2.knowledge.KnowledgeChangedEvent knowledge_changed_event = 734;
     */
    value: KnowledgeChangedEvent;
    case: "knowledgeChangedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeckChangedEvent deck_changed_event = 735;
     */
    value: DeckChangedEvent;
    case: "deckChangedEvent";
  } | {
    /**
     * REC-CANCEL-01 cancel a running transcription (749-750). Non-contiguous
     * with the B10 recordings block (60-71) because those tags are wire
     * identity and can never be renumbered to tidy the grouping.
     *
     * @generated from field: lvdr.v2.recordings.CancelTranscriptionRequest cancel_transcription_request = 749;
     */
    value: CancelTranscriptionRequest;
    case: "cancelTranscriptionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.recordings.CancelTranscriptionResponse cancel_transcription_response = 750;
     */
    value: CancelTranscriptionResponse;
    case: "cancelTranscriptionResponse";
  } | {
    /**
     * TASKS-08 "which tasks came from this note" (751-752). Mirrors the note
     * list-by-link pair at 588-589 — same question, opposite direction.
     *
     * @generated from field: lvdr.v2.tasks.ListTasksByLinkRequest list_tasks_by_link_request = 751;
     */
    value: ListTasksByLinkRequest;
    case: "listTasksByLinkRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.ListTasksByLinkResponse list_tasks_by_link_response = 752;
     */
    value: ListTasksByLinkResponse;
    case: "listTasksByLinkResponse";
  } | {
    /**
     * Chat starter-prompt catalog (753-754) — CHAT-36
     *
     * @generated from field: lvdr.v2.chatprompts.ListChatPromptsRequest list_chat_prompts_request = 753;
     */
    value: ListChatPromptsRequest;
    case: "listChatPromptsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chatprompts.ListChatPromptsResponse list_chat_prompts_response = 754;
     */
    value: ListChatPromptsResponse;
    case: "listChatPromptsResponse";
  } | {
    /**
     * INBOX-02b inbox control plane (755-763)
     *
     * @generated from field: lvdr.v2.inbox.InboxListMailboxesRequest inbox_list_mailboxes_request = 755;
     */
    value: InboxListMailboxesRequest;
    case: "inboxListMailboxesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxListMailboxesResponse inbox_list_mailboxes_response = 756;
     */
    value: InboxListMailboxesResponse;
    case: "inboxListMailboxesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTestMailboxRequest inbox_test_mailbox_request = 757;
     */
    value: InboxTestMailboxRequest;
    case: "inboxTestMailboxRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTestMailboxResponse inbox_test_mailbox_response = 758;
     */
    value: InboxTestMailboxResponse;
    case: "inboxTestMailboxResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxConnectMailboxRequest inbox_connect_mailbox_request = 759;
     */
    value: InboxConnectMailboxRequest;
    case: "inboxConnectMailboxRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxConnectMailboxResponse inbox_connect_mailbox_response = 760;
     */
    value: InboxConnectMailboxResponse;
    case: "inboxConnectMailboxResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxDisconnectMailboxRequest inbox_disconnect_mailbox_request = 761;
     */
    value: InboxDisconnectMailboxRequest;
    case: "inboxDisconnectMailboxRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxDisconnectMailboxResponse inbox_disconnect_mailbox_response = 762;
     */
    value: InboxDisconnectMailboxResponse;
    case: "inboxDisconnectMailboxResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSyncProgress inbox_sync_progress = 763;
     */
    value: InboxSyncProgress;
    case: "inboxSyncProgress";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetCallSourceRequest inbox_set_call_source_request = 764;
     */
    value: InboxSetCallSourceRequest;
    case: "inboxSetCallSourceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetCallSourceResponse inbox_set_call_source_response = 765;
     */
    value: InboxSetCallSourceResponse;
    case: "inboxSetCallSourceResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.GetTurnTraceRequest get_turn_trace_request = 766;
     */
    value: GetTurnTraceRequest;
    case: "getTurnTraceRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.GetTurnTraceResponse get_turn_trace_response = 767;
     */
    value: GetTurnTraceResponse;
    case: "getTurnTraceResponse";
  } | {
    /**
     * CHAT-47 daily note get-or-create (768); reply is NoteResponse
     *
     * @generated from field: lvdr.v2.note.GetOrCreateDailyNoteRequest get_or_create_daily_note_request = 768;
     */
    value: GetOrCreateDailyNoteRequest;
    case: "getOrCreateDailyNoteRequest";
  } | {
    /**
     * INBOX-05c triage surface (769-779)
     *
     * @generated from field: lvdr.v2.inbox.InboxListTriageRequest inbox_list_triage_request = 769;
     */
    value: InboxListTriageRequest;
    case: "inboxListTriageRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxListTriageResponse inbox_list_triage_response = 770;
     */
    value: InboxListTriageResponse;
    case: "inboxListTriageResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetTriageLabelRequest inbox_set_triage_label_request = 771;
     */
    value: InboxSetTriageLabelRequest;
    case: "inboxSetTriageLabelRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetTriageLabelResponse inbox_set_triage_label_response = 772;
     */
    value: InboxSetTriageLabelResponse;
    case: "inboxSetTriageLabelResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxConfirmRuleProposalRequest inbox_confirm_rule_proposal_request = 773;
     */
    value: InboxConfirmRuleProposalRequest;
    case: "inboxConfirmRuleProposalRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxConfirmRuleProposalResponse inbox_confirm_rule_proposal_response = 774;
     */
    value: InboxConfirmRuleProposalResponse;
    case: "inboxConfirmRuleProposalResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetTriageCountRequest inbox_get_triage_count_request = 775;
     */
    value: InboxGetTriageCountRequest;
    case: "inboxGetTriageCountRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetTriageCountResponse inbox_get_triage_count_response = 776;
     */
    value: InboxGetTriageCountResponse;
    case: "inboxGetTriageCountResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTriageCount inbox_triage_count = 777;
     */
    value: InboxTriageCount;
    case: "inboxTriageCount";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetTriageReportRequest inbox_get_triage_report_request = 778;
     */
    value: InboxGetTriageReportRequest;
    case: "inboxGetTriageReportRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetTriageReportResponse inbox_get_triage_report_response = 779;
     */
    value: InboxGetTriageReportResponse;
    case: "inboxGetTriageReportResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetContextCardRequest inbox_get_context_card_request = 780;
     */
    value: InboxGetContextCardRequest;
    case: "inboxGetContextCardRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetContextCardResponse inbox_get_context_card_response = 781;
     */
    value: InboxGetContextCardResponse;
    case: "inboxGetContextCardResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetInteractionTextRequest inbox_get_interaction_text_request = 782;
     */
    value: InboxGetInteractionTextRequest;
    case: "inboxGetInteractionTextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetInteractionTextResponse inbox_get_interaction_text_response = 783;
     */
    value: InboxGetInteractionTextResponse;
    case: "inboxGetInteractionTextResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetLoopDismissedRequest inbox_set_loop_dismissed_request = 784;
     */
    value: InboxSetLoopDismissedRequest;
    case: "inboxSetLoopDismissedRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetLoopDismissedResponse inbox_set_loop_dismissed_response = 785;
     */
    value: InboxSetLoopDismissedResponse;
    case: "inboxSetLoopDismissedResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.InterjectRequest interject_request = 786;
     */
    value: InterjectRequest;
    case: "interjectRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.InterjectResponse interject_response = 787;
     */
    value: InterjectResponse;
    case: "interjectResponse";
  } | {
    /**
     * WF-33 workflow run result (788). Pushed UNSOLICITED by workflow.RealtimeHub — its
     * own message, not a reused *Response (see the RT-01 note above).
     *
     * @generated from field: lvdr.v2.workflow.WorkflowResultEvent workflow_result = 788;
     */
    value: WorkflowResultEvent;
    case: "workflowResult";
  } | {
    /**
     * AON-06 (789-792): move a connector credential between Private and the
     * always-on space; resume a step suspended on a space-held reconnect.
     *
     * @generated from field: lvdr.v2.connector.MoveConnectionRequest move_connection_request = 789;
     */
    value: MoveConnectionRequest;
    case: "moveConnectionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.connector.MoveConnectionResponse move_connection_response = 790;
     */
    value: MoveConnectionResponse;
    case: "moveConnectionResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ResumeReconnectWorkflowStepRequest resume_reconnect_workflow_step_request = 791;
     */
    value: ResumeReconnectWorkflowStepRequest;
    case: "resumeReconnectWorkflowStepRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ResumeReconnectWorkflowStepResponse resume_reconnect_workflow_step_response = 792;
     */
    value: ResumeReconnectWorkflowStepResponse;
    case: "resumeReconnectWorkflowStepResponse";
  } | {
    /**
     * INBOX-07 reply draft (793-798).
     *
     * @generated from field: lvdr.v2.inbox.InboxDraftReplyRequest inbox_draft_reply_request = 793;
     */
    value: InboxDraftReplyRequest;
    case: "inboxDraftReplyRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxDraftReplyResponse inbox_draft_reply_response = 794;
     */
    value: InboxDraftReplyResponse;
    case: "inboxDraftReplyResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetDraftContextRequest inbox_get_draft_context_request = 795;
     */
    value: InboxGetDraftContextRequest;
    case: "inboxGetDraftContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetDraftContextResponse inbox_get_draft_context_response = 796;
     */
    value: InboxGetDraftContextResponse;
    case: "inboxGetDraftContextResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetStyleOverrideRequest inbox_set_style_override_request = 797;
     */
    value: InboxSetStyleOverrideRequest;
    case: "inboxSetStyleOverrideRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetStyleOverrideResponse inbox_set_style_override_response = 798;
     */
    value: InboxSetStyleOverrideResponse;
    case: "inboxSetStyleOverrideResponse";
  } | {
    /**
     * COS-16 needs-you inbox (799-803).
     *
     * @generated from field: lvdr.v2.needsyou.NeedsYouListRequest needs_you_list_request = 799;
     */
    value: NeedsYouListRequest;
    case: "needsYouListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.needsyou.NeedsYouListResponse needs_you_list_response = 800;
     */
    value: NeedsYouListResponse;
    case: "needsYouListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.needsyou.NeedsYouResolveRequest needs_you_resolve_request = 801;
     */
    value: NeedsYouResolveRequest;
    case: "needsYouResolveRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.needsyou.NeedsYouResolveResponse needs_you_resolve_response = 802;
     */
    value: NeedsYouResolveResponse;
    case: "needsYouResolveResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.needsyou.NeedsYouChangedEvent needs_you_changed_event = 803;
     */
    value: NeedsYouChangedEvent;
    case: "needsYouChangedEvent";
  } | {
    /**
     * AON-11 bridge release page and step arming (804-811).
     *
     * @generated from field: lvdr.v2.bridge.BridgeRequestGetRequest bridge_request_get_request = 804;
     */
    value: BridgeRequestGetRequest;
    case: "bridgeRequestGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeRequestGetResponse bridge_request_get_response = 805;
     */
    value: BridgeRequestGetResponse;
    case: "bridgeRequestGetResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeDraftRequest bridge_draft_request = 806;
     */
    value: BridgeDraftRequest;
    case: "bridgeDraftRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeDraftResponse bridge_draft_response = 807;
     */
    value: BridgeDraftResponse;
    case: "bridgeDraftResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeResolveRequest bridge_resolve_request = 808;
     */
    value: BridgeResolveRequest;
    case: "bridgeResolveRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeResolveResponse bridge_resolve_response = 809;
     */
    value: BridgeResolveResponse;
    case: "bridgeResolveResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeSetSendApprovalRequest bridge_set_send_approval_request = 810;
     */
    value: BridgeSetSendApprovalRequest;
    case: "bridgeSetSendApprovalRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bridge.BridgeSetSendApprovalResponse bridge_set_send_approval_response = 811;
     */
    value: BridgeSetSendApprovalResponse;
    case: "bridgeSetSendApprovalResponse";
  } | {
    /**
     * INBOX-20b: clear-label, and the "Also me" self handles.
     *
     * @generated from field: lvdr.v2.inbox.InboxClearTriageLabelRequest inbox_clear_triage_label_request = 812;
     */
    value: InboxClearTriageLabelRequest;
    case: "inboxClearTriageLabelRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxClearTriageLabelResponse inbox_clear_triage_label_response = 813;
     */
    value: InboxClearTriageLabelResponse;
    case: "inboxClearTriageLabelResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxListSelfHandlesRequest inbox_list_self_handles_request = 814;
     */
    value: InboxListSelfHandlesRequest;
    case: "inboxListSelfHandlesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxListSelfHandlesResponse inbox_list_self_handles_response = 815;
     */
    value: InboxListSelfHandlesResponse;
    case: "inboxListSelfHandlesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetSelfHandlesRequest inbox_set_self_handles_request = 816;
     */
    value: InboxSetSelfHandlesRequest;
    case: "inboxSetSelfHandlesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetSelfHandlesResponse inbox_set_self_handles_response = 817;
     */
    value: InboxSetSelfHandlesResponse;
    case: "inboxSetSelfHandlesResponse";
  } | {
    /**
     * INBOX-21 conversation thread (828-829: first pair above every wave-9 number; see the field ledger).
     *
     * @generated from field: lvdr.v2.inbox.InboxGetConversationRequest inbox_get_conversation_request = 828;
     */
    value: InboxGetConversationRequest;
    case: "inboxGetConversationRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetConversationResponse inbox_get_conversation_response = 829;
     */
    value: InboxGetConversationResponse;
    case: "inboxGetConversationResponse";
  } | {
    /**
     * INBOX-22: the triage rules view (get / preview / set, 818-823) and the pending-proposal dismiss (830-831).
     *
     * @generated from field: lvdr.v2.inbox.InboxGetConvRulesRequest inbox_get_conv_rules_request = 818;
     */
    value: InboxGetConvRulesRequest;
    case: "inboxGetConvRulesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxGetConvRulesResponse inbox_get_conv_rules_response = 819;
     */
    value: InboxGetConvRulesResponse;
    case: "inboxGetConvRulesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxPreviewConvRulesRequest inbox_preview_conv_rules_request = 820;
     */
    value: InboxPreviewConvRulesRequest;
    case: "inboxPreviewConvRulesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxPreviewConvRulesResponse inbox_preview_conv_rules_response = 821;
     */
    value: InboxPreviewConvRulesResponse;
    case: "inboxPreviewConvRulesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetConvRulesRequest inbox_set_conv_rules_request = 822;
     */
    value: InboxSetConvRulesRequest;
    case: "inboxSetConvRulesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetConvRulesResponse inbox_set_conv_rules_response = 823;
     */
    value: InboxSetConvRulesResponse;
    case: "inboxSetConvRulesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxDismissRuleProposalRequest inbox_dismiss_rule_proposal_request = 830;
     */
    value: InboxDismissRuleProposalRequest;
    case: "inboxDismissRuleProposalRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxDismissRuleProposalResponse inbox_dismiss_rule_proposal_response = 831;
     */
    value: InboxDismissRuleProposalResponse;
    case: "inboxDismissRuleProposalResponse";
  } | {
    /**
     * INBOX-23 mailbox label + filter (824-827, reserved by INBOX-22's plan).
     *
     * @generated from field: lvdr.v2.inbox.InboxSetMailboxLabelRequest inbox_set_mailbox_label_request = 824;
     */
    value: InboxSetMailboxLabelRequest;
    case: "inboxSetMailboxLabelRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetMailboxLabelResponse inbox_set_mailbox_label_response = 825;
     */
    value: InboxSetMailboxLabelResponse;
    case: "inboxSetMailboxLabelResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetMailboxFilterRequest inbox_set_mailbox_filter_request = 826;
     */
    value: InboxSetMailboxFilterRequest;
    case: "inboxSetMailboxFilterRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxSetMailboxFilterResponse inbox_set_mailbox_filter_response = 827;
     */
    value: InboxSetMailboxFilterResponse;
    case: "inboxSetMailboxFilterResponse";
  } | {
    /**
     * INBOX-13a Telegram connect + status (832-835).
     *
     * @generated from field: lvdr.v2.inbox.InboxTelegramConnectRequest inbox_telegram_connect_request = 832;
     */
    value: InboxTelegramConnectRequest;
    case: "inboxTelegramConnectRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTelegramConnectResponse inbox_telegram_connect_response = 833;
     */
    value: InboxTelegramConnectResponse;
    case: "inboxTelegramConnectResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTelegramStatusRequest inbox_telegram_status_request = 834;
     */
    value: InboxTelegramStatusRequest;
    case: "inboxTelegramStatusRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.inbox.InboxTelegramStatusResponse inbox_telegram_status_response = 835;
     */
    value: InboxTelegramStatusResponse;
    case: "inboxTelegramStatusResponse";
  } | {
    /**
     * MEM-09a Contexts core (836-859).
     *
     * @generated from field: lvdr.v2.context.ContextGraphGetRequest context_graph_get_request = 836;
     */
    value: ContextGraphGetRequest;
    case: "contextGraphGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextGraphResponse context_graph_response = 837;
     */
    value: ContextGraphResponse;
    case: "contextGraphResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextNodeCreateRequest context_node_create_request = 838;
     */
    value: ContextNodeCreateRequest;
    case: "contextNodeCreateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextNodeUpdateRequest context_node_update_request = 839;
     */
    value: ContextNodeUpdateRequest;
    case: "contextNodeUpdateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextNodeSetParentsRequest context_node_set_parents_request = 840;
     */
    value: ContextNodeSetParentsRequest;
    case: "contextNodeSetParentsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextNodeArchiveRequest context_node_archive_request = 841;
     */
    value: ContextNodeArchiveRequest;
    case: "contextNodeArchiveRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextNodeResponse context_node_response = 842;
     */
    value: ContextNodeResponse;
    case: "contextNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLinksGetRequest context_links_get_request = 843;
     */
    value: ContextLinksGetRequest;
    case: "contextLinksGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLinksSetRequest context_links_set_request = 844;
     */
    value: ContextLinksSetRequest;
    case: "contextLinksSetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLinksResponse context_links_response = 845;
     */
    value: ContextLinksResponse;
    case: "contextLinksResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextItemsOnNodeRequest context_items_on_node_request = 846;
     */
    value: ContextItemsOnNodeRequest;
    case: "contextItemsOnNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextItemsOnNodeResponse context_items_on_node_response = 847;
     */
    value: ContextItemsOnNodeResponse;
    case: "contextItemsOnNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalsListRequest context_proposals_list_request = 848;
     */
    value: ContextProposalsListRequest;
    case: "contextProposalsListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalsListResponse context_proposals_list_response = 849;
     */
    value: ContextProposalsListResponse;
    case: "contextProposalsListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalsApplyRequest context_proposals_apply_request = 850;
     */
    value: ContextProposalsApplyRequest;
    case: "contextProposalsApplyRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalDismissRequest context_proposal_dismiss_request = 851;
     */
    value: ContextProposalDismissRequest;
    case: "contextProposalDismissRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalsApplyResponse context_proposals_apply_response = 852;
     */
    value: ContextProposalsApplyResponse;
    case: "contextProposalsApplyResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextHistoryListRequest context_history_list_request = 853;
     */
    value: ContextHistoryListRequest;
    case: "contextHistoryListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextHistoryListResponse context_history_list_response = 854;
     */
    value: ContextHistoryListResponse;
    case: "contextHistoryListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextUndoRequest context_undo_request = 855;
     */
    value: ContextUndoRequest;
    case: "contextUndoRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextUndoResponse context_undo_response = 856;
     */
    value: ContextUndoResponse;
    case: "contextUndoResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLastUsedGetRequest context_last_used_get_request = 857;
     */
    value: ContextLastUsedGetRequest;
    case: "contextLastUsedGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLastUsedSetRequest context_last_used_set_request = 858;
     */
    value: ContextLastUsedSetRequest;
    case: "contextLastUsedSetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextLastUsedResponse context_last_used_response = 859;
     */
    value: ContextLastUsedResponse;
    case: "contextLastUsedResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeToContextPreviewRequest scope_to_context_preview_request = 860;
     */
    value: ScopeToContextPreviewRequest;
    case: "scopeToContextPreviewRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeToContextPreviewResponse scope_to_context_preview_response = 861;
     */
    value: ScopeToContextPreviewResponse;
    case: "scopeToContextPreviewResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeToContextApplyRequest scope_to_context_apply_request = 862;
     */
    value: ScopeToContextApplyRequest;
    case: "scopeToContextApplyRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.document.ScopeToContextApplyResponse scope_to_context_apply_response = 863;
     */
    value: ScopeToContextApplyResponse;
    case: "scopeToContextApplyResponse";
  } | {
    /**
     * MEM-09c chat on Contexts (864-869).
     *
     * @generated from field: lvdr.v2.chat.MoveChatSessionContextRequest move_chat_session_context_request = 864;
     */
    value: MoveChatSessionContextRequest;
    case: "moveChatSessionContextRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.MoveChatSessionContextResponse move_chat_session_context_response = 865;
     */
    value: MoveChatSessionContextResponse;
    case: "moveChatSessionContextResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.CountChatSessionFactsRequest count_chat_session_facts_request = 866;
     */
    value: CountChatSessionFactsRequest;
    case: "countChatSessionFactsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.CountChatSessionFactsResponse count_chat_session_facts_response = 867;
     */
    value: CountChatSessionFactsResponse;
    case: "countChatSessionFactsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.SaveChatNoteRequest save_chat_note_request = 868;
     */
    value: SaveChatNoteRequest;
    case: "saveChatNoteRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.chat.SaveChatNoteResponse save_chat_note_response = 869;
     */
    value: SaveChatNoteResponse;
    case: "saveChatNoteResponse";
  } | {
    /**
     * MEM-09e item classification (870-872).
     *
     * @generated from field: lvdr.v2.context.ContextItemClassificationGetRequest context_item_classification_get_request = 870;
     */
    value: ContextItemClassificationGetRequest;
    case: "contextItemClassificationGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextItemClassificationSetRequest context_item_classification_set_request = 871;
     */
    value: ContextItemClassificationSetRequest;
    case: "contextItemClassificationSetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextItemClassificationResponse context_item_classification_response = 872;
     */
    value: ContextItemClassificationResponse;
    case: "contextItemClassificationResponse";
  } | {
    /**
     * MEM-12 the Contexts space (873-887).
     *
     * @generated from field: lvdr.v2.context.ContextOperateRequest context_operate_request = 873;
     */
    value: ContextOperateRequest;
    case: "contextOperateRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextOperateResponse context_operate_response = 874;
     */
    value: ContextOperateResponse;
    case: "contextOperateResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextInspectRequest context_inspect_request = 875;
     */
    value: ContextInspectRequest;
    case: "contextInspectRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextInspection context_inspection = 876;
     */
    value: ContextInspection;
    case: "contextInspection";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextPreviewPropertiesRequest context_preview_properties_request = 877;
     */
    value: ContextPreviewPropertiesRequest;
    case: "contextPreviewPropertiesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextImpactPreview context_impact_preview = 878;
     */
    value: ContextImpactPreview;
    case: "contextImpactPreview";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextUnsortedListRequest context_unsorted_list_request = 879;
     */
    value: ContextUnsortedListRequest;
    case: "contextUnsortedListRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextUnsortedListResponse context_unsorted_list_response = 880;
     */
    value: ContextUnsortedListResponse;
    case: "contextUnsortedListResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextEraseExportRequest context_erase_export_request = 881;
     */
    value: ContextEraseExportRequest;
    case: "contextEraseExportRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextEraseExportResponse context_erase_export_response = 882;
     */
    value: ContextEraseExportResponse;
    case: "contextEraseExportResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextEraseRequest context_erase_request = 883;
     */
    value: ContextEraseRequest;
    case: "contextEraseRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextEraseResponse context_erase_response = 884;
     */
    value: ContextEraseResponse;
    case: "contextEraseResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextFactsOnNodeRequest context_facts_on_node_request = 885;
     */
    value: ContextFactsOnNodeRequest;
    case: "contextFactsOnNodeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextFactsOnNodeResponse context_facts_on_node_response = 886;
     */
    value: ContextFactsOnNodeResponse;
    case: "contextFactsOnNodeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextProposalsChangedEvent context_proposals_changed_event = 887;
     */
    value: ContextProposalsChangedEvent;
    case: "contextProposalsChangedEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextPersonalityGetRequest context_personality_get_request = 888;
     */
    value: ContextPersonalityGetRequest;
    case: "contextPersonalityGetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextPersonalitySetRequest context_personality_set_request = 889;
     */
    value: ContextPersonalitySetRequest;
    case: "contextPersonalitySetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextPersonalityResponse context_personality_response = 890;
     */
    value: ContextPersonalityResponse;
    case: "contextPersonalityResponse";
  } | {
    /**
     * MEM-09n: file a transfer unit on Workspace nodes.
     *
     * @generated from field: lvdr.v2.context.ContextUnitLinksSetRequest context_unit_links_set_request = 891;
     */
    value: ContextUnitLinksSetRequest;
    case: "contextUnitLinksSetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextUnitLinksSetResponse context_unit_links_set_response = 892;
     */
    value: ContextUnitLinksSetResponse;
    case: "contextUnitLinksSetResponse";
  } | {
    /**
     * MEM-10: the deterministic contexts signal pass.
     *
     * @generated from field: lvdr.v2.context.ContextSignalsRunRequest context_signals_run_request = 893;
     */
    value: ContextSignalsRunRequest;
    case: "contextSignalsRunRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.context.ContextSignalsRunResponse context_signals_run_response = 894;
     */
    value: ContextSignalsRunResponse;
    case: "contextSignalsRunResponse";
  } | {
    /**
     * COS-14 web push wake
     *
     * @generated from field: lvdr.v2.bgauth.GetPushConfigRequest get_push_config_request = 895;
     */
    value: GetPushConfigRequest;
    case: "getPushConfigRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.RegisterPushSubscriptionRequest register_push_subscription_request = 896;
     */
    value: RegisterPushSubscriptionRequest;
    case: "registerPushSubscriptionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.RemovePushSubscriptionRequest remove_push_subscription_request = 897;
     */
    value: RemovePushSubscriptionRequest;
    case: "removePushSubscriptionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.PushConfigResponse push_config_response = 898;
     */
    value: PushConfigResponse;
    case: "pushConfigResponse";
  } | {
    /**
     * COS-27 work batches (899-902).
     *
     * @generated from field: lvdr.v2.cos.ListWorkBatchesRequest list_work_batches_request = 899;
     */
    value: ListWorkBatchesRequest;
    case: "listWorkBatchesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ListWorkBatchesResponse list_work_batches_response = 900;
     */
    value: ListWorkBatchesResponse;
    case: "listWorkBatchesResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.UpdateWorkBatchOverridesRequest update_work_batch_overrides_request = 901;
     */
    value: UpdateWorkBatchOverridesRequest;
    case: "updateWorkBatchOverridesRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.UpdateWorkBatchOverridesResponse update_work_batch_overrides_response = 902;
     */
    value: UpdateWorkBatchOverridesResponse;
    case: "updateWorkBatchOverridesResponse";
  } | {
    /**
     * COS-14b sealed openings (903-904).
     *
     * @generated from field: lvdr.v2.bgauth.ListSealedOpeningsRequest list_sealed_openings_request = 903;
     */
    value: ListSealedOpeningsRequest;
    case: "listSealedOpeningsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.bgauth.ListSealedOpeningsResponse list_sealed_openings_response = 904;
     */
    value: ListSealedOpeningsResponse;
    case: "listSealedOpeningsResponse";
  } | {
    /**
     * COS-25 next work (905-908).
     *
     * @generated from field: lvdr.v2.cos.GetNextWorkRequest get_next_work_request = 905;
     */
    value: GetNextWorkRequest;
    case: "getNextWorkRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetNextWorkResponse get_next_work_response = 906;
     */
    value: GetNextWorkResponse;
    case: "getNextWorkResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ReportActivityRequest report_activity_request = 907;
     */
    value: ReportActivityRequest;
    case: "reportActivityRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ReportActivityResponse report_activity_response = 908;
     */
    value: ReportActivityResponse;
    case: "reportActivityResponse";
  } | {
    /**
     * COS-26 attention suggestions (909-911).
     *
     * @generated from field: lvdr.v2.tasks.SuggestTaskAttentionRequest suggest_task_attention_request = 909;
     */
    value: SuggestTaskAttentionRequest;
    case: "suggestTaskAttentionRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.SuggestTaskAttentionResponse suggest_task_attention_response = 910;
     */
    value: SuggestTaskAttentionResponse;
    case: "suggestTaskAttentionResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.tasks.ResolveTaskAttentionSuggestionRequest resolve_task_attention_suggestion_request = 911;
     */
    value: ResolveTaskAttentionSuggestionRequest;
    case: "resolveTaskAttentionSuggestionRequest";
  } | {
    /**
     * COS-28 briefings (912-918).
     *
     * @generated from field: lvdr.v2.cos.PrepareBriefingsRequest prepare_briefings_request = 912;
     */
    value: PrepareBriefingsRequest;
    case: "prepareBriefingsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.PrepareBriefingsResponse prepare_briefings_response = 913;
     */
    value: PrepareBriefingsResponse;
    case: "prepareBriefingsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetBriefingRequest get_briefing_request = 914;
     */
    value: GetBriefingRequest;
    case: "getBriefingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetBriefingResponse get_briefing_response = 915;
     */
    value: GetBriefingResponse;
    case: "getBriefingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.OpenedBriefingRequest opened_briefing_request = 916;
     */
    value: OpenedBriefingRequest;
    case: "openedBriefingRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.OpenedBriefingResponse opened_briefing_response = 917;
     */
    value: OpenedBriefingResponse;
    case: "openedBriefingResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.BriefingUpdatedEvent briefing_updated_event = 918;
     */
    value: BriefingUpdatedEvent;
    case: "briefingUpdatedEvent";
  } | {
    /**
     * COS-29 interruptions (919-929).
     *
     * @generated from field: lvdr.v2.cos.InterruptionEvent interruption_event = 919;
     */
    value: InterruptionEvent;
    case: "interruptionEvent";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.InterruptionActRequest interruption_act_request = 920;
     */
    value: InterruptionActRequest;
    case: "interruptionActRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.InterruptionActResponse interruption_act_response = 921;
     */
    value: InterruptionActResponse;
    case: "interruptionActResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.SetTellMeRequest set_tell_me_request = 922;
     */
    value: SetTellMeRequest;
    case: "setTellMeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.SetTellMeResponse set_tell_me_response = 923;
     */
    value: SetTellMeResponse;
    case: "setTellMeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ListTellMeRequest list_tell_me_request = 924;
     */
    value: ListTellMeRequest;
    case: "listTellMeRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ListTellMeResponse list_tell_me_response = 925;
     */
    value: ListTellMeResponse;
    case: "listTellMeResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ListRecentInterruptionsRequest list_recent_interruptions_request = 926;
     */
    value: ListRecentInterruptionsRequest;
    case: "listRecentInterruptionsRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.ListRecentInterruptionsResponse list_recent_interruptions_response = 927;
     */
    value: ListRecentInterruptionsResponse;
    case: "listRecentInterruptionsResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetInterruptBudgetRequest get_interrupt_budget_request = 928;
     */
    value: GetInterruptBudgetRequest;
    case: "getInterruptBudgetRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetInterruptBudgetResponse get_interrupt_budget_response = 929;
     */
    value: GetInterruptBudgetResponse;
    case: "getInterruptBudgetResponse";
  } | {
    /**
     * HOME-03 focus sprints (930-940).
     *
     * @generated from field: lvdr.v2.cos.DraftFocusSprintRequest draft_focus_sprint_request = 930;
     */
    value: DraftFocusSprintRequest;
    case: "draftFocusSprintRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.DraftFocusSprintResponse draft_focus_sprint_response = 931;
     */
    value: DraftFocusSprintResponse;
    case: "draftFocusSprintResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.StartFocusSprintRequest start_focus_sprint_request = 932;
     */
    value: StartFocusSprintRequest;
    case: "startFocusSprintRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.StartFocusSprintResponse start_focus_sprint_response = 933;
     */
    value: StartFocusSprintResponse;
    case: "startFocusSprintResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetFocusSprintRequest get_focus_sprint_request = 934;
     */
    value: GetFocusSprintRequest;
    case: "getFocusSprintRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.GetFocusSprintResponse get_focus_sprint_response = 935;
     */
    value: GetFocusSprintResponse;
    case: "getFocusSprintResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.UpdateFocusSprintRequest update_focus_sprint_request = 936;
     */
    value: UpdateFocusSprintRequest;
    case: "updateFocusSprintRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.UpdateFocusSprintResponse update_focus_sprint_response = 937;
     */
    value: UpdateFocusSprintResponse;
    case: "updateFocusSprintResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.EndFocusSprintRequest end_focus_sprint_request = 938;
     */
    value: EndFocusSprintRequest;
    case: "endFocusSprintRequest";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.EndFocusSprintResponse end_focus_sprint_response = 939;
     */
    value: EndFocusSprintResponse;
    case: "endFocusSprintResponse";
  } | {
    /**
     * @generated from field: lvdr.v2.cos.FocusSprintEvent focus_sprint_event = 940;
     */
    value: FocusSprintEvent;
    case: "focusSprintEvent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.envelope.MessageEnvelope.
 * Use `create(MessageEnvelopeSchema)` to create a new message.
 */
export const MessageEnvelopeSchema: GenMessage<MessageEnvelope> = /*@__PURE__*/
  messageDesc(file_envelope_envelope, 0);

/**
 * Connection messages (defined here, not in a separate domain)
 *
 * @generated from message lvdr.v2.envelope.Ping
 */
export type Ping = Message<"lvdr.v2.envelope.Ping"> & {
};

/**
 * Describes the message lvdr.v2.envelope.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_envelope_envelope, 1);

/**
 * @generated from message lvdr.v2.envelope.Pong
 */
export type Pong = Message<"lvdr.v2.envelope.Pong"> & {
};

/**
 * Describes the message lvdr.v2.envelope.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_envelope_envelope, 2);

